
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("gqiCO", function(module, exports) {
$parcel$export(module.exports, "ConnectedProformaRequestCreate", () => $48f85d7839bee9f8$export$d89b789da0162253);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $4ZMmh = parcelRequire("4ZMmh");

var $gUbcQ = parcelRequire("gUbcQ");

var $1biTA = parcelRequire("1biTA");

var $ik9zp = parcelRequire("ik9zp");

var $ay2XP = parcelRequire("ay2XP");

var $9PwDt = parcelRequire("9PwDt");

var $iOfAl = parcelRequire("iOfAl");
const $48f85d7839bee9f8$var$RequestCreateApp = ({ blockFormSubmission: // OwnProps
blockFormSubmission, fieldErrors: fieldErrors, knowledgeBase: knowledgeBase, locale: locale, portalId: portalId, registerProformaForm: registerProformaForm, reporterAccountId: reporterAccountId, requestTypeId: requestTypeId, mediaApiError: // StateProps
mediaApiError, mediaApiUploadToken: mediaApiUploadToken, projectId: projectId, proformaFormIsDirty: proformaFormIsDirty, proformaTemplateForm: proformaTemplateForm, serviceDeskId: serviceDeskId, fetchPortalUploadMediaToken: // DispatchProps
fetchPortalUploadMediaToken, setProformaFormDirtyAction: setProformaFormDirtyAction, renderFormFinished: onFormRendererLifecycleStageRenderComplete })=>{
    // Build media upload config
    const updateMediaUploadToken = (0, $bSJIT.useCallback)(()=>{
        fetchPortalUploadMediaToken(portalId);
    }, [
        portalId,
        fetchPortalUploadMediaToken
    ]);
    const mediaUploadConfig = (0, $bSJIT.useMemo)(()=>{
        if (!mediaApiUploadToken) return {
            baseUrl: '',
            collection: '',
            clientId: '',
            token: '',
            updateToken: (0, $4ZMmh.noop)
        };
        return {
            baseUrl: mediaApiUploadToken.endpointUrl,
            collection: mediaApiUploadToken.targetCollection,
            clientId: mediaApiUploadToken.clientId,
            token: mediaApiUploadToken.token,
            updateToken: updateMediaUploadToken
        };
    }, [
        mediaApiUploadToken,
        updateMediaUploadToken
    ]);
    // Fetch media upload token on mount if not already loaded
    (0, $bSJIT.useEffect)(()=>{
        if (!mediaApiUploadToken && !mediaApiError) updateMediaUploadToken();
    }, [
        mediaApiUploadToken,
        mediaApiError,
        updateMediaUploadToken
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9PwDt.Box), {
        testId: "connected-proforma-request-create"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iOfAl.ProformaRequestCreate), {
        blockFormSubmission: blockFormSubmission,
        fieldErrors: fieldErrors,
        knowledgeBase: knowledgeBase,
        locale: locale,
        mediaUploadConfig: mediaUploadConfig,
        onRenderComplete: onFormRendererLifecycleStageRenderComplete,
        portalId: portalId,
        proformaFormIsDirty: proformaFormIsDirty,
        proformaTemplateForm: proformaTemplateForm,
        projectId: projectId,
        registerProformaForm: registerProformaForm,
        reporterAccountId: reporterAccountId,
        requestTypeId: requestTypeId,
        serviceDeskId: serviceDeskId,
        setProformaFormDirtyAction: setProformaFormDirtyAction
    }));
};
const $48f85d7839bee9f8$export$d89b789da0162253 = (0, $egQxE.connect)((state, { portalId: portalId, requestTypeId: requestTypeId })=>({
        mediaApiError: (0, $ik9zp.getMediaApiError)(state, portalId),
        mediaApiUploadToken: (0, $ik9zp.getMediaApiUploadToken)(state, portalId),
        projectId: (0, $ik9zp.getProjectId)(state, portalId),
        proformaFormIsDirty: (0, $ay2XP.getIsProformaFormDirty)(state, portalId, requestTypeId),
        proformaTemplateForm: (0, $ay2XP.getProformaTemplateForm)(state, portalId, requestTypeId),
        serviceDeskId: (0, $ik9zp.getServiceDeskId)(state, portalId)
    }), {
    fetchPortalUploadMediaToken: (0, $gUbcQ.fetchPortalUploadMediaTokenAction),
    setProformaFormDirtyAction: (0, $1biTA.proformaFormDirtyAction)
})($48f85d7839bee9f8$var$RequestCreateApp);

});
parcelRegister("iOfAl", function(module, exports) {
$parcel$export(module.exports, "ProformaRequestCreate", () => $c88552a54fb0e406$export$94cc35dc118c897);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $6WltM = parcelRequire("6WltM");

var $dwOcU = parcelRequire("dwOcU");

var $bf1Bt = parcelRequire("bf1Bt");

var $VnB4y = parcelRequire("VnB4y");

var $gUpf2 = parcelRequire("gUpf2");

var $hDkm2 = parcelRequire("hDkm2");

var $k2MWg = parcelRequire("k2MWg");

var $clpci = parcelRequire("clpci");

var $iW3CQ = parcelRequire("iW3CQ");

var $5KLgR = parcelRequire("5KLgR");

var $lCetE = parcelRequire("lCetE");

var $8dotP = parcelRequire("8dotP");

var $qIDsl = parcelRequire("qIDsl");

var $UUFWv = parcelRequire("UUFWv");

var $5JwFL = parcelRequire("5JwFL");

var $azuRz = parcelRequire("azuRz");

var $2nfpZ = parcelRequire("2nfpZ");

var $gkoaJ = parcelRequire("gkoaJ");

var $8wHrE = parcelRequire("8wHrE");

var $h5lZ1 = parcelRequire("h5lZ1");

var $429NB = parcelRequire("429NB");

var $hcE22 = parcelRequire("hcE22");

var $9OtAk = parcelRequire("9OtAk");

var $iSvpt = parcelRequire("iSvpt");

var $dAWhD = parcelRequire("dAWhD");

var $9aH4T = parcelRequire("9aH4T");

var $kZukY = parcelRequire("kZukY");

var $63xql = parcelRequire("63xql");

var $fUCfn = parcelRequire("fUCfn");

var $9U9T0 = parcelRequire("9U9T0");

var $ly1uh = parcelRequire("ly1uh");

var $5smeJ = parcelRequire("5smeJ");

var $fJGzM = parcelRequire("fJGzM");

var $lJULG = parcelRequire("lJULG");
const $c88552a54fb0e406$var$styles = {
    formRendererWrapper: "_1pfh1e9d _12l2tdkl _6rthtdkl _ahbqtdkl",
    spinnerBackdrop: "_1ccl1e9d _dk5didpf _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1h6o"
};
const $c88552a54fb0e406$var$proformaEnvironment = {
    [(0, $iW3CQ.EnvType).LOCAL]: (0, $8dotP.Environment).LOCAL,
    [(0, $iW3CQ.EnvType).DEV]: (0, $8dotP.Environment).DEVELOPMENT,
    [(0, $iW3CQ.EnvType).STAGING]: (0, $8dotP.Environment).STAGING,
    [(0, $iW3CQ.EnvType).PROD]: (0, $8dotP.Environment).PRODUCTION
};
const $c88552a54fb0e406$export$94cc35dc118c897 = ({ blockFormSubmission: blockFormSubmission, fieldErrors: fieldErrors, knowledgeBase: knowledgeBase, locale: locale, mediaUploadConfig: mediaUploadConfig, onRenderComplete: onRenderComplete, portalId: portalId, proformaFormIsDirty: proformaFormIsDirty, proformaTemplateForm: proformaTemplateForm, projectId: projectId, registerProformaForm: registerProformaForm, reporterAccountId: reporterAccountId, requestTypeId: requestTypeId, serviceDeskId: serviceDeskId, setProformaFormDirtyAction: setProformaFormDirtyAction })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $9OtAk.ProformaRequestCreateContextProvider), {
        blockFormSubmission: blockFormSubmission,
        fieldErrors: fieldErrors,
        initialMediaUploadConfig: mediaUploadConfig,
        knowledgeBase: knowledgeBase,
        locale: locale,
        portalId: portalId,
        proformaFormIsDirty: proformaFormIsDirty,
        proformaTemplateForm: proformaTemplateForm,
        projectId: projectId,
        registerProformaForm: registerProformaForm,
        reporterAccountId: reporterAccountId,
        requestTypeId: requestTypeId,
        serviceDeskId: serviceDeskId,
        setProformaFormDirtyAction: setProformaFormDirtyAction
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5JwFL.FormRendererContainer), null, /*#__PURE__*/ $bSJIT.createElement((0, $bf1Bt.FlagsProvider), null, /*#__PURE__*/ $bSJIT.createElement((0, $hcE22.AnalyticsProvider), null, /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            source: `proformaJiraPortalCreate${(0, $clpci.SCREEN)}`,
            attributes: {
                serviceDeskId: serviceDeskId,
                requestTypeId: requestTypeId,
                projectId: projectId,
                projectType: 'service_desk'
            }
        }
    }, /*#__PURE__*/ $bSJIT.createElement($c88552a54fb0e406$var$ProformaRequestCreateWithErrorHandling, {
        onRenderComplete: onRenderComplete
    }))))));
};
/**
 * Wrapper that provides PfErrorUtilsProvider so useRefreshForm (and its useGetFieldDataService)
 * can call usePfErrorUtils. Must wrap ProformaRequestCreateInner before any hooks that need
 * errorUtils run.
 *
 * Why this cannot live in ProformaRequestCreate: errorUtils is created from useAnalyticsEvents()
 * and useFlags(), which require the component to be inside AnalyticsContext and FlagsProvider.
 * ProformaRequestCreate renders those providers (it sits above them), so it cannot call those
 * hooks. This intermediate component lives inside the provider tree and can create errorUtils,
 * then pass it to ErrorBoundary and UtilsProvider.
 */ const $c88552a54fb0e406$var$ProformaRequestCreateWithErrorHandling = ({ onRenderComplete: onRenderComplete })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    const environment = $c88552a54fb0e406$var$proformaEnvironment[(0, $iW3CQ.getEnv)().environment];
    const errorUtils = (0, $bSJIT.useMemo)(()=>(0, $qIDsl.createErrorUtils)('PortalCreate', environment, createAnalyticsEvent, showFlag), [
        createAnalyticsEvent,
        environment,
        showFlag
    ]);
    return /*#__PURE__*/ $bSJIT.createElement((0, $5KLgR.ErrorBoundary), {
        errorUtils: errorUtils
    }, /*#__PURE__*/ $bSJIT.createElement((0, $lCetE.UtilsProvider), {
        utils: {
            errorUtils: errorUtils
        }
    }, /*#__PURE__*/ $bSJIT.createElement($c88552a54fb0e406$var$ProformaRequestCreateFormLoader, {
        onRenderComplete: onRenderComplete
    })));
};
const $c88552a54fb0e406$var$ProformaRequestCreateFormLoader = ({ onRenderComplete: onRenderComplete })=>{
    const forms = (0, $9OtAk.useForms)();
    const proformaTemplateForm = (0, $9OtAk.useProformaTemplateForm)();
    const { refreshForm: refreshForm, isFetchingFieldData: isFetchingFieldData, isFetchingFormChoices: isFetchingFormChoices } = (0, $iSvpt.useRefreshForm)();
    (0, $bSJIT.useEffect)(()=>{
        if (proformaTemplateForm && !forms) refreshForm(proformaTemplateForm).catch(()=>{
        // Error handling is done in the hook
        });
    }, [
        proformaTemplateForm,
        forms,
        refreshForm
    ]);
    if (!proformaTemplateForm) return null;
    if (isFetchingFieldData || isFetchingFormChoices || !forms) return /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "proforma-request-create.loading",
        className: (0, $9fU1q.default)([
            $c88552a54fb0e406$var$styles.spinnerBackdrop
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
        size: "large"
    }));
    const proformaForm = forms.proformaForm;
    return /*#__PURE__*/ $bSJIT.createElement($c88552a54fb0e406$var$ProformaRequestCreateForm, {
        forms: forms,
        proformaForm: proformaForm,
        onRenderComplete: onRenderComplete
    });
};
/**
 * Renders the form when forms data is ready. Split out so that hooks depending on forms
 * (useJiraFieldData, useValidationFieldSet, useAsyncConfig, etc.) are only called when
 * this component is mounted, preserving the Rule of Hooks.
 */ const $c88552a54fb0e406$var$ProformaRequestCreateForm = ({ forms: forms, proformaForm: proformaForm, onRenderComplete: onRenderComplete })=>{
    var _proformaForm$design, _proformaForm$design2, _proformaForm$design3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const locale = (0, $9OtAk.useLocale)();
    const jiraFieldData = (0, $9OtAk.useJiraFieldData)();
    const validationFieldSet = (0, $9OtAk.useValidationFieldSet)();
    const asyncFields = (0, $dAWhD.useAsyncConfig)(jiraFieldData, proformaForm);
    const attachmentConfiguration = (0, $9aH4T.useAttachmentConfiguration)();
    const onAttachmentUploadEnd = (0, $kZukY.useAttachmentUploadEnd)();
    const { summaryFieldId: summaryFieldId, knowledgeBaseArticles: knowledgeBaseArticles, onFieldChanged: handleKnowledgeBaseSuggestionsOnFieldChanged } = (0, $fJGzM.useKnowledgeBaseSuggestions)(proformaForm);
    const { onFieldChanged: handleCmdbDefaultsOnFieldChanged } = (0, $63xql.useCmdbDefaults)(proformaForm);
    const onProformaFormDirty = (0, $lJULG.useProformaFormDirty)();
    (0, $9U9T0.useFormikRegisterProformaForm)(forms);
    (0, $9U9T0.useFormikFieldErrors)(forms);
    (0, $9U9T0.useFormikBlockSubmissionDuringUpload)();
    const formViewedAttributes = (0, $bSJIT.useMemo)(()=>(0, $fUCfn.buildFormViewedAnalyticsAttributes)(proformaForm, locale), [
        proformaForm,
        locale
    ]);
    const displayLocale = (proformaForm === null || proformaForm === void 0 || (_proformaForm$design = proformaForm.design) === null || _proformaForm$design === void 0 || (_proformaForm$design = _proformaForm$design.settings) === null || _proformaForm$design === void 0 ? void 0 : _proformaForm$design.translatedLocale) ?? (proformaForm === null || proformaForm === void 0 || (_proformaForm$design2 = proformaForm.design) === null || _proformaForm$design2 === void 0 || (_proformaForm$design2 = _proformaForm$design2.settings) === null || _proformaForm$design2 === void 0 ? void 0 : _proformaForm$design2.primaryLocale) ?? (proformaForm === null || proformaForm === void 0 || (_proformaForm$design3 = proformaForm.design) === null || _proformaForm$design3 === void 0 || (_proformaForm$design3 = _proformaForm$design3.settings) === null || _proformaForm$design3 === void 0 ? void 0 : _proformaForm$design3.language) ?? locale;
    const lifecycleHandlers = (0, $bSJIT.useMemo)(()=>({
            [(0, $azuRz.FormRendererLifecycleStage).RENDER_COMPLETE]: ()=>{
                onRenderComplete();
                (0, $k2MWg.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $429NB.ActionSubject).FORM} ${(0, $429NB.Action).VIEWED}`, 'proformaRenderForm', formViewedAttributes);
            },
            [(0, $azuRz.FormRendererLifecycleStage).ATTACHMENT_UPLOAD_END]: onAttachmentUploadEnd,
            [(0, $azuRz.FormRendererLifecycleStage).FIELD_CHANGED]: (event)=>{
                // `FieldId` is typed as `string` in `@atlassian/proforma-form-renderer` (`common/types/form/form-fields/index.ts`),
                // but ADF layout stores question ids as JSON numbers in many legacy templates.
                // FormRenderer passes through ADF `parameters.id` without coercion; it may be a number at runtime while
                // `proformaForm.design.questions` keys are strings. Normalize once here so lifecycle handlers can assume string ids.
                // See ARCHITECTURE.md ("FIELD_CHANGED fieldId").
                // See platform/packages/proforma/proforma-form-renderer/src/common/utils/sections/types.tsx for callout that legacy data may have numeric ids.
                const normalizedEvent = {
                    ...event,
                    fieldId: String(event.fieldId)
                };
                handleKnowledgeBaseSuggestionsOnFieldChanged(normalizedEvent);
                handleCmdbDefaultsOnFieldChanged(normalizedEvent);
                onProformaFormDirty();
            }
        }), [
        onRenderComplete,
        onAttachmentUploadEnd,
        handleKnowledgeBaseSuggestionsOnFieldChanged,
        handleCmdbDefaultsOnFieldChanged,
        onProformaFormDirty,
        createAnalyticsEvent,
        formViewedAttributes
    ]);
    const renderers = (0, $bSJIT.useMemo)(()=>({
            formFieldComponentRenderers: {
                Container: {
                    [(0, $2nfpZ.FormFieldType).SHORT_TEXT]: (0, $5smeJ.KnowledgeBaseSuggestionFieldContainer),
                    [(0, $2nfpZ.FormFieldType).LONG_TEXT]: (0, $5smeJ.KnowledgeBaseSuggestionFieldContainer)
                }
            }
        }), []);
    return /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), {
        testId: "proforma-request-create"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $h5lZ1.NoticeProvider), null, /*#__PURE__*/ $bSJIT.createElement((0, $ly1uh.KnowledgeBaseSuggestionsContextProvider), {
        summaryFieldId: summaryFieldId,
        knowledgeBaseArticles: knowledgeBaseArticles
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "proforma-request-create.form-renderer",
        className: (0, $9fU1q.default)([
            $c88552a54fb0e406$var$styles.formRendererWrapper
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $UUFWv.FormRenderer), {
        renderMode: (0, $gkoaJ.FormRenderMode).EDIT,
        form: forms.form,
        locale: displayLocale,
        fieldVisibility: {
            fieldSet: [
                (0, $8wHrE.VisibilityFieldSet).VISIBLE_SECTION_FIELDS
            ]
        },
        fieldValidation: {
            validationTargets: {
                fieldSet: validationFieldSet
            }
        },
        attachmentConfiguration: attachmentConfiguration,
        asyncFields: asyncFields,
        lifecycleHandlers: lifecycleHandlers,
        renderers: renderers
    })))));
};

});
parcelRegister("9OtAk", function(module, exports) {
$parcel$export(module.exports, "ProformaRequestCreateContextProvider", () => $000a2c48ba1d7af7$export$175fd33bf4d97f5e);
$parcel$export(module.exports, "useLocale", () => $000a2c48ba1d7af7$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "usePortalId", () => $000a2c48ba1d7af7$export$27bb594bbc4fe7c3);
$parcel$export(module.exports, "useRequestTypeId", () => $000a2c48ba1d7af7$export$4951403fb38a8a1c);
$parcel$export(module.exports, "useServiceDeskId", () => $000a2c48ba1d7af7$export$5fefa0a414912e67);
$parcel$export(module.exports, "useProjectId", () => $000a2c48ba1d7af7$export$16d1475ed6c26568);
$parcel$export(module.exports, "useMediaUploadConfig", () => $000a2c48ba1d7af7$export$ffb924f1d1f524e1);
$parcel$export(module.exports, "useProformaTemplateForm", () => $000a2c48ba1d7af7$export$c06b78fbc9556e54);
$parcel$export(module.exports, "useReporterAccountId", () => $000a2c48ba1d7af7$export$6a30f15a769ee93);
$parcel$export(module.exports, "useKnowledgeBase", () => $000a2c48ba1d7af7$export$d64e79b2f91f30d7);
$parcel$export(module.exports, "useBlockFormSubmission", () => $000a2c48ba1d7af7$export$97825987a707ca79);
$parcel$export(module.exports, "useFieldErrors", () => $000a2c48ba1d7af7$export$cebfdd2506906eeb);
$parcel$export(module.exports, "useRegisterProformaForm", () => $000a2c48ba1d7af7$export$500b8ea4d070a82b);
$parcel$export(module.exports, "useSetProformaFormDirty", () => $000a2c48ba1d7af7$export$80c1662fe9093eb9);
$parcel$export(module.exports, "useProformaFormIsDirty", () => $000a2c48ba1d7af7$export$31f3c6f57c615c35);
$parcel$export(module.exports, "useJiraFieldData", () => $000a2c48ba1d7af7$export$1b950343bd4ae54e);
$parcel$export(module.exports, "useSetJiraFieldData", () => $000a2c48ba1d7af7$export$bb58a0352aa857cc);
$parcel$export(module.exports, "useForms", () => $000a2c48ba1d7af7$export$4f95a4085cc93847);
$parcel$export(module.exports, "useSetForms", () => $000a2c48ba1d7af7$export$ea68a5d31ccfb9d0);
$parcel$export(module.exports, "useValidationFieldSet", () => $000a2c48ba1d7af7$export$e0082e10f330d78a);
$parcel$export(module.exports, "useSetValidationFieldSet", () => $000a2c48ba1d7af7$export$8adcaeee138d54fc);

var $bSJIT = parcelRequire("bSJIT");

var $fI1BQ = parcelRequire("fI1BQ");

var $82gbm = parcelRequire("82gbm");
const $000a2c48ba1d7af7$var$INITIAL_MEDIA_CONFIG = {
    baseUrl: '',
    clientId: '',
    token: '',
    updateToken: (0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ)))
};
const $000a2c48ba1d7af7$var$INITIAL_SET_MEDIA_CONFIG = {
    setMediaUploadConfig: (0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ)))
};
const $000a2c48ba1d7af7$var$LocaleContext = /*#__PURE__*/ (0, $bSJIT.createContext)('en_US');
const $000a2c48ba1d7af7$var$PortalIdContext = /*#__PURE__*/ (0, $bSJIT.createContext)(0);
const $000a2c48ba1d7af7$var$RequestTypeIdContext = /*#__PURE__*/ (0, $bSJIT.createContext)(0);
const $000a2c48ba1d7af7$var$ServiceDeskIdContext = /*#__PURE__*/ (0, $bSJIT.createContext)(0);
const $000a2c48ba1d7af7$var$ProjectIdContext = /*#__PURE__*/ (0, $bSJIT.createContext)(0);
const $000a2c48ba1d7af7$var$MediaUploadConfigContext = /*#__PURE__*/ (0, $bSJIT.createContext)($000a2c48ba1d7af7$var$INITIAL_MEDIA_CONFIG);
const $000a2c48ba1d7af7$var$SetMediaConfigContext = /*#__PURE__*/ (0, $bSJIT.createContext)($000a2c48ba1d7af7$var$INITIAL_SET_MEDIA_CONFIG);
const $000a2c48ba1d7af7$var$ProformaTemplateFormContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$ReporterAccountIdContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$KnowledgeBaseContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$BlockFormSubmissionContext = /*#__PURE__*/ (0, $bSJIT.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ))));
const $000a2c48ba1d7af7$var$FieldErrorsContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$RegisterProformaFormContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$SetProformaFormDirtyContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$ProformaFormIsDirtyContext = /*#__PURE__*/ (0, $bSJIT.createContext)(false);
const $000a2c48ba1d7af7$var$JiraFieldDataContext = /*#__PURE__*/ (0, $bSJIT.createContext)(new Map());
const $000a2c48ba1d7af7$var$SetJiraFieldDataContext = /*#__PURE__*/ (0, $bSJIT.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ))));
const $000a2c48ba1d7af7$var$FormsContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $000a2c48ba1d7af7$var$SetFormsContext = /*#__PURE__*/ (0, $bSJIT.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ))));
const $000a2c48ba1d7af7$var$ValidationFieldSetContext = /*#__PURE__*/ (0, $bSJIT.createContext)((0, $82gbm.ValidationFieldSet).MODIFIED_FIELDS);
const $000a2c48ba1d7af7$var$SetValidationFieldSetContext = /*#__PURE__*/ (0, $bSJIT.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($fI1BQ))));
const $000a2c48ba1d7af7$export$175fd33bf4d97f5e = ({ children: children, locale: locale, portalId: portalId, requestTypeId: requestTypeId, serviceDeskId: serviceDeskId, projectId: projectId, initialMediaUploadConfig: initialMediaUploadConfig, proformaTemplateForm: proformaTemplateForm, reporterAccountId: reporterAccountId, knowledgeBase: knowledgeBase, blockFormSubmission: blockFormSubmission, fieldErrors: fieldErrors, registerProformaForm: registerProformaForm, proformaFormIsDirty: proformaFormIsDirty, setProformaFormDirtyAction: setProformaFormDirtyAction })=>{
    const [mediaUploadConfig, setMediaUploadConfig] = (0, $bSJIT.useState)(initialMediaUploadConfig);
    const setMediaConfig = (0, $bSJIT.useMemo)(()=>({
            setMediaUploadConfig: setMediaUploadConfig
        }), [
        setMediaUploadConfig
    ]);
    const [jiraFieldData, setJiraFieldData] = (0, $bSJIT.useState)(new Map());
    const [forms, setForms] = (0, $bSJIT.useState)(undefined);
    const [validationFieldSet, setValidationFieldSet] = (0, $bSJIT.useState)((0, $82gbm.ValidationFieldSet).MODIFIED_FIELDS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$LocaleContext.Provider, {
        value: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$PortalIdContext.Provider, {
        value: portalId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$RequestTypeIdContext.Provider, {
        value: requestTypeId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$ServiceDeskIdContext.Provider, {
        value: serviceDeskId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$ProjectIdContext.Provider, {
        value: projectId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$MediaUploadConfigContext.Provider, {
        value: mediaUploadConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$SetMediaConfigContext.Provider, {
        value: setMediaConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$ProformaTemplateFormContext.Provider, {
        value: proformaTemplateForm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$ReporterAccountIdContext.Provider, {
        value: reporterAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$KnowledgeBaseContext.Provider, {
        value: knowledgeBase
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$BlockFormSubmissionContext.Provider, {
        value: blockFormSubmission
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$FieldErrorsContext.Provider, {
        value: fieldErrors
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$RegisterProformaFormContext.Provider, {
        value: registerProformaForm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$SetProformaFormDirtyContext.Provider, {
        value: setProformaFormDirtyAction
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$ProformaFormIsDirtyContext.Provider, {
        value: proformaFormIsDirty
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$JiraFieldDataContext.Provider, {
        value: jiraFieldData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$SetJiraFieldDataContext.Provider, {
        value: setJiraFieldData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$FormsContext.Provider, {
        value: forms
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$SetFormsContext.Provider, {
        value: setForms
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$ValidationFieldSetContext.Provider, {
        value: validationFieldSet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($000a2c48ba1d7af7$var$SetValidationFieldSetContext.Provider, {
        value: setValidationFieldSet
    }, children)))))))))))))))))))));
};
const $000a2c48ba1d7af7$export$43bb16f9c6d9e3f7 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$LocaleContext);
const $000a2c48ba1d7af7$export$27bb594bbc4fe7c3 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$PortalIdContext);
const $000a2c48ba1d7af7$export$4951403fb38a8a1c = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$RequestTypeIdContext);
const $000a2c48ba1d7af7$export$5fefa0a414912e67 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$ServiceDeskIdContext);
const $000a2c48ba1d7af7$export$16d1475ed6c26568 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$ProjectIdContext);
const $000a2c48ba1d7af7$export$ffb924f1d1f524e1 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$MediaUploadConfigContext);
const $000a2c48ba1d7af7$export$8e0bee1973fca1ee = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$SetMediaConfigContext);
const $000a2c48ba1d7af7$export$c06b78fbc9556e54 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$ProformaTemplateFormContext);
const $000a2c48ba1d7af7$export$6a30f15a769ee93 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$ReporterAccountIdContext);
const $000a2c48ba1d7af7$export$d64e79b2f91f30d7 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$KnowledgeBaseContext);
const $000a2c48ba1d7af7$export$97825987a707ca79 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$BlockFormSubmissionContext);
const $000a2c48ba1d7af7$export$cebfdd2506906eeb = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$FieldErrorsContext);
const $000a2c48ba1d7af7$export$500b8ea4d070a82b = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$RegisterProformaFormContext);
const $000a2c48ba1d7af7$export$80c1662fe9093eb9 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$SetProformaFormDirtyContext);
const $000a2c48ba1d7af7$export$31f3c6f57c615c35 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$ProformaFormIsDirtyContext);
const $000a2c48ba1d7af7$export$1b950343bd4ae54e = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$JiraFieldDataContext);
const $000a2c48ba1d7af7$export$bb58a0352aa857cc = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$SetJiraFieldDataContext);
const $000a2c48ba1d7af7$export$4f95a4085cc93847 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$FormsContext);
const $000a2c48ba1d7af7$export$ea68a5d31ccfb9d0 = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$SetFormsContext);
const $000a2c48ba1d7af7$export$e0082e10f330d78a = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$ValidationFieldSetContext);
const $000a2c48ba1d7af7$export$8adcaeee138d54fc = ()=>(0, $bSJIT.useContext)($000a2c48ba1d7af7$var$SetValidationFieldSetContext);

});

parcelRegister("iSvpt", function(module, exports) {
$parcel$export(module.exports, "useRefreshForm", () => $012195152fcd9330$export$2e0eddf623b976a4);

var $bSJIT = parcelRequire("bSJIT");

var $dS4H4 = parcelRequire("dS4H4");

var $9syXG = parcelRequire("9syXG");

var $9OtAk = parcelRequire("9OtAk");

var $aaY8v = parcelRequire("aaY8v");
var $a4AUr = parcelRequire("a4AUr");
const $012195152fcd9330$export$2e0eddf623b976a4 = ()=>{
    const { fetch: fetchFieldData, loading: isFetchingFieldData, error: fetchFieldDataError } = (0, $aaY8v.useGetFieldDataService)();
    const { fetch: fetchFormChoices, loading: isFetchingFormChoices, error: fetchFormChoicesError } = (0, $a4AUr.useGetFormChoicesService)();
    const setJiraFieldData = (0, $9OtAk.useSetJiraFieldData)();
    const setForms = (0, $9OtAk.useSetForms)();
    const refreshForm = (0, $bSJIT.useCallback)(async (form)=>{
        const hasJiraFields = Object.values(form.design.questions).some((question)=>question.jiraField);
        const hasDataConnectionFields = Object.values(form.design.questions).some((question)=>question.dcId);
        const shouldFetchFormChoices = hasJiraFields || hasDataConnectionFields;
        const shouldFetchFieldData = hasJiraFields;
        // Fetch enrichment data (field data and form choices) individually, catching errors
        // so the form still renders gracefully without enrichment when APIs fail (e.g. 403).
        // Error reporting and user notifications are already handled in proformaGasAnalyticsFetch.
        const [fieldData, formChoices] = await Promise.all([
            shouldFetchFieldData ? fetchFieldData({
                templateFormId: form.id,
                fieldDataRequest: {
                    fields: Object.values(form.design.questions).filter((question)=>question.jiraField).map((question)=>({
                            fieldKey: question.jiraField || '',
                            ...question.type === (0, $dS4H4.FormQuestionType).RichTextParagraph && {
                                format: 'adf'
                            }
                        }))
                }
            }).catch(()=>undefined) : Promise.resolve(undefined),
            shouldFetchFormChoices ? fetchFormChoices().catch(()=>undefined) : Promise.resolve(undefined)
        ]);
        if (fieldData) setJiraFieldData(new Map(Object.entries(fieldData)));
        // For request-create, always apply default values (4th param = true)
        // Cast TemplateForm to ProformaForm - the uuid field is optional in common-core but required in form-renderer types
        const convertedForm = (0, $9syXG.convertToForm)(form, fieldData, formChoices, true);
        const forms = {
            form: convertedForm,
            proformaForm: form
        };
        setForms(forms);
        return forms;
    }, [
        fetchFieldData,
        fetchFormChoices,
        setJiraFieldData,
        setForms
    ]);
    return {
        fetchFieldDataError: fetchFieldDataError,
        fetchFormChoicesError: fetchFormChoicesError,
        refreshForm: refreshForm,
        isFetchingFieldData: isFetchingFieldData,
        isFetchingFormChoices: isFetchingFormChoices
    };
};

});
parcelRegister("aaY8v", function(module, exports) {
$parcel$export(module.exports, "useGetFieldDataService", () => $cd139d6e4efc24bc$export$931ca76b6da244e9);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $fuVmc = parcelRequire("fuVmc");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $2MXlX = parcelRequire("2MXlX");
const $cd139d6e4efc24bc$export$931ca76b6da244e9 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const cloudId = (0, $fuVmc.getCloudId)();
    const serviceDeskId = (0, $9OtAk.useServiceDeskId)();
    const requestTypeId = (0, $9OtAk.useRequestTypeId)();
    const request = (0, $bSJIT.useCallback)((requestData)=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`${(0, $2MXlX.PROFORMA_STARGATE_URL_PREFIX)}/${cloudId}/api/cloud/portal/${serviceDeskId}/requesttype/${requestTypeId}/form/${requestData.templateFormId}/fielddata`, {
            method: 'POST',
            body: JSON.stringify(requestData.fieldDataRequest)
        }, createAnalyticsEvent, errorUtils), [
        cloudId,
        serviceDeskId,
        requestTypeId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});
parcelRegister("1TyDZ", function(module, exports) {
$parcel$export(module.exports, "proformaGasAnalyticsFetch", () => $f22b36fddf1fe4a3$export$b187597bb298fd7);

var $ezwN8 = parcelRequire("ezwN8");

var $5juzF = parcelRequire("5juzF");

var $1YJEf = parcelRequire("1YJEf");

var $429NB = parcelRequire("429NB");
var $f22b36fddf1fe4a3$export$9126c50ecfe2a46d = /*#__PURE__*/ function(AcceptedResponseType) {
    AcceptedResponseType["Json"] = "json";
    AcceptedResponseType["Blob"] = "blob";
    return AcceptedResponseType;
}({});
/**
 * Local types for constructing ApiError, matching the definition in proforma-common-core
 * These are not exported from the package, so we define them here.
 */ // oxlint-disable-next-line no-shadow
var $f22b36fddf1fe4a3$var$ErrorContext = /*#__PURE__*/ function(ErrorContext) {
    ErrorContext["I18nAccessPathKey"] = "err.access.path";
    ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
    ErrorContext["I18nEntityFormKey"] = "err.entity.form";
    ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
    ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
    ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
    ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
    ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
    ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
    ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
    ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
    ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
    ErrorContext["I18nInternalServerError"] = "err.server.internal";
    ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
    return ErrorContext;
}($f22b36fddf1fe4a3$var$ErrorContext || {});
/**
 * Local function to convert a string to ErrorContext, matching proforma-common-core implementation
 */ function $f22b36fddf1fe4a3$var$ErrorContextOf(context) {
    switch(context){
        case "err.access.path":
            return "err.access.path";
        case "err.entity.connection":
            return "err.entity.connection";
        case "err.entity.form":
            return "err.entity.form";
        case "err.entity.issue":
            return "err.entity.issue";
        case "err.entity.issue.create":
            return "err.entity.issue.create";
        case "err.entity.preferredform":
            return "err.entity.preferredform";
        case "err.entity.project":
            return "err.entity.project";
        case "err.entity.requesttype":
            return "err.entity.requesttype";
        case "err.entity.servicedesk":
            return "err.entity.servicedesk";
        case "err.jwt.parse":
            return "err.jwt.parse";
        case "err.jwt.signed":
            return "err.jwt.signed";
        case "err.jwt.verify":
            return "err.jwt.verify";
        case "err.server.internal":
            return "err.server.internal";
        default:
            return "err.context.unknown";
    }
}
/**
 * Converts HeadersInit to a Record<string, string> for safe assignment
 */ function $f22b36fddf1fe4a3$var$toHeadersRecord(headers) {
    if (headers instanceof Headers) {
        const record = {};
        headers.forEach((value, key)=>{
            record[key] = value;
        });
        return record;
    }
    if (Array.isArray(headers)) {
        const record = {};
        headers.forEach(([key, value])=>{
            record[key] = value;
        });
        return record;
    }
    return headers;
}
/**
 * Constructs an API error object.
 * This is a local implementation matching the original from proforma-common-core/ApiError.ts
 * since constructApiError is not exported from proforma-common-core package.
 */ function $f22b36fddf1fe4a3$var$constructApiError(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
    switch(error){
        case (0, $1YJEf.ApiErrorType).client:
            return {
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName,
                error: (0, $1YJEf.ApiErrorType).client
            };
        case (0, $1YJEf.ApiErrorType).clientWithDetails:
            return {
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName,
                error: (0, $1YJEf.ApiErrorType).clientWithDetails,
                context: $f22b36fddf1fe4a3$var$ErrorContextOf(context),
                details: details || ''
            };
        case (0, $1YJEf.ApiErrorType).json:
            return {
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName,
                error: (0, $1YJEf.ApiErrorType).json,
                details: details || ''
            };
        case (0, $1YJEf.ApiErrorType).jwt:
            return {
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName,
                error: (0, $1YJEf.ApiErrorType).jwt,
                details: details || ''
            };
        default:
            return {
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                requestName: requestName,
                status: status,
                responseJson: responseJson,
                error: (0, $1YJEf.ApiErrorType).unknown,
                message: error
            };
    }
}
function $f22b36fddf1fe4a3$var$getAnalyticsSource(createAnalyticsEvent) {
    try {
        var _analyticsData$payloa;
        const analyticsEvent = createAnalyticsEvent({});
        const analyticsData = (0, $ezwN8.extractAWCDataFromEvent)(analyticsEvent);
        const source = analyticsData === null || analyticsData === void 0 || (_analyticsData$payloa = analyticsData.payload) === null || _analyticsData$payloa === void 0 ? void 0 : _analyticsData$payloa.source;
        return typeof source === 'string' ? source : 'unknown';
    } catch (e) {
        return 'unknown';
    }
}
function $f22b36fddf1fe4a3$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
    if (Object.keys(responseJson).length === 0) return $f22b36fddf1fe4a3$var$constructApiError(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
    const error = String(responseJson.error) || `Unexpected API reply (HTTP/${status})`;
    const context = String(responseJson.context ?? '');
    const contextId = String(responseJson.contextId ?? '');
    const details = String(responseJson.details ?? '');
    return $f22b36fddf1fe4a3$var$constructApiError(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
}
async function $f22b36fddf1fe4a3$export$b187597bb298fd7(input, init, createAnalyticsEvent, errorUtils, responseType = 'json', requestName) {
    const analyticsSource = $f22b36fddf1fe4a3$var$getAnalyticsSource(createAnalyticsEvent);
    // Merge the analytics headers with any existing headers from init
    const headers = {
        'Content-Type': 'application/json',
        'X-Experimental-Experience': analyticsSource,
        ...responseType === "json" ? {
            Accept: 'application/json'
        } : {},
        ...init !== null && init !== void 0 && init.headers ? $f22b36fddf1fe4a3$var$toHeadersRecord(init.headers) : {}
    };
    const fetchInit = {
        credentials: (init === null || init === void 0 ? void 0 : init.credentials) ?? 'same-origin',
        ...init ? {
            ...init,
            headers: undefined
        } : {},
        headers: headers
    };
    // Extract path and method for error reporting
    let path;
    if (typeof input === 'string') path = input;
    else if (input instanceof URL) path = input.toString();
    else path = 'unknown';
    const method = (init === null || init === void 0 ? void 0 : init.method) ?? 'GET';
    return fetch(input, fetchInit).catch((error)=>{
        const fetchError = error instanceof Error ? error : new Error(String(error));
        const message = `No response from API: ${fetchError.message || ''}`;
        const apiError = $f22b36fddf1fe4a3$var$toApiError(0, {
            error: message
        }, true, requestName);
        errorUtils.reportError(fetchError, {
            actionSubject: (0, $429NB.ActionSubject).PROFORMA_API,
            id: 'fetchApi',
            attributes: {
                path: path,
                method: method,
                responseType: responseType,
                requestName: requestName,
                apiError: JSON.stringify(apiError),
                isClientFetchError: true
            }
        });
        return Promise.reject(apiError);
    }).then((response)=>{
        let errorObj = new Error(response.statusText);
        if (!response.ok) {
            const traceId = response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? undefined;
            let apiErrorPromise;
            try {
                // Try to parse response error details
                const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$f22b36fddf1fe4a3$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                    const jsonError = error instanceof Error ? error : new Error(String(error));
                    const message = `Failed to parse error response as JSON from API: ${jsonError.message || ''}`;
                    errorObj = jsonError;
                    return $f22b36fddf1fe4a3$var$toApiError(response.status, {
                        error: message
                    }, false, requestName, traceId);
                });
                if (response.status === 401) errorUtils.notifyUser((0, $5juzF.NoticeType).ErrorApiUnauthorised).catch(()=>{
                // Notification error handling is not critical
                });
                if (response.status === 403) errorUtils.notifyUser((0, $5juzF.NoticeType).ErrorApiMissingPermissions).catch(()=>{
                // Notification error handling is not critical
                });
                if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                else // Create error object with error response body
                apiErrorPromise = Promise.reject($f22b36fddf1fe4a3$var$toApiError(response.status, {
                    error: response.body || ''
                }, false, requestName, traceId));
            } catch (error) {
                // Nothing blocking this lint issue being fixed, but leaving as ignored for now to lower surface area for potential
                // regressions between this and the platform ApiUtil implementation, and this entire function will be gone once
                // moving to UFO anyway.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                const message = `Unexpected response from API: ${response.body || ''}`;
                errorObj = error;
                apiErrorPromise = Promise.reject($f22b36fddf1fe4a3$var$toApiError(response.status, {
                    error: message
                }, false, requestName, traceId));
            }
            apiErrorPromise.catch((apiError)=>{
                errorUtils.reportError(errorObj, {
                    actionSubject: (0, $429NB.ActionSubject).PROFORMA_API,
                    id: 'fetchApi',
                    attributes: {
                        method: method,
                        path: path,
                        requestName: requestName,
                        responseType: responseType,
                        traceId: traceId,
                        apiError: JSON.stringify(apiError),
                        isClientFetchError: false,
                        status: response.status,
                        statusGroup: `${Math.floor(response.status / 100)}xx`
                    }
                });
            });
            return apiErrorPromise;
        }
        if (response.status === 204) return '';
        switch(responseType){
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'none':
                return '';
            default:
                return response;
        }
    });
}

});

parcelRegister("2MXlX", function(module, exports) {
$parcel$export(module.exports, "PROFORMA_STARGATE_URL_PREFIX", () => $061ddc2faff1a6e8$export$58ae643215ae6416);
$parcel$export(module.exports, "JSM_CUSTOMER_PORTAL_URL_PREFIX", () => $061ddc2faff1a6e8$export$a0490bb923bd8739);
$parcel$export(module.exports, "APOLLO_STARGATE_URL_PREFIX", () => $061ddc2faff1a6e8$export$757bffe5657e4fba);
const $061ddc2faff1a6e8$export$58ae643215ae6416 = '/gateway/api/proforma/portal/cloudid';
const $061ddc2faff1a6e8$export$a0490bb923bd8739 = '/rest/servicedesk/1/customer/portal';
const $061ddc2faff1a6e8$export$757bffe5657e4fba = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

});


parcelRegister("a4AUr", function(module, exports) {
$parcel$export(module.exports, "useGetFormChoicesService", () => $aab2d8f31eec2d49$export$8826419e1f70883e);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $fuVmc = parcelRequire("fuVmc");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $2MXlX = parcelRequire("2MXlX");
const $aab2d8f31eec2d49$export$8826419e1f70883e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const cloudId = (0, $fuVmc.getCloudId)();
    const serviceDeskId = (0, $9OtAk.useServiceDeskId)();
    const requestTypeId = (0, $9OtAk.useRequestTypeId)();
    const request = (0, $bSJIT.useCallback)(()=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`${(0, $2MXlX.PROFORMA_STARGATE_URL_PREFIX)}/${cloudId}/api/3/portal/${serviceDeskId}/requesttype/${requestTypeId}/formchoices`, {
            method: 'GET'
        }, createAnalyticsEvent, errorUtils), [
        cloudId,
        serviceDeskId,
        requestTypeId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});


parcelRegister("dAWhD", function(module, exports) {
$parcel$export(module.exports, "useAsyncConfig", () => $077fde3b52013cd0$export$92ae9fb02efd1f26);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $fyqAM = parcelRequire("fyqAM");

var $1lJtA = parcelRequire("1lJtA");

var $i1Yim = parcelRequire("i1Yim");

var $2KwTs = parcelRequire("2KwTs");

var $jscd0 = parcelRequire("jscd0");

var $1l3d7 = parcelRequire("1l3d7");

var $4ZyLG = parcelRequire("4ZyLG");

var $cWpoJ = parcelRequire("cWpoJ");

var $4ZcCE = parcelRequire("4ZcCE");

var $lrO5j = parcelRequire("lrO5j");

var $17ShZ = parcelRequire("17ShZ");

const $077fde3b52013cd0$export$f78302df54eb22ff = (proformaForm, jiraFieldData, affectedServicesFn, cmdbObjectsFn, labelsFn, usersFn, usersConfiguredFn, createAnalyticsEvent, errorUtils)=>{
    const asyncConfigs = {};
    const questions = Object.entries(proformaForm.design.questions);
    questions.forEach(([fieldId, field])=>{
        const jiraFieldKey = field.jiraField;
        let config;
        if ((0, $cWpoJ.isUserField)(field.type)) config = (0, $lrO5j.resolveUserConfig)(jiraFieldKey, jiraFieldData, usersConfiguredFn, usersFn);
        else if (jiraFieldKey) {
            const fieldData = jiraFieldData.get(jiraFieldKey);
            if (fieldData !== undefined) config = (0, $4ZcCE.resolveSchemaConfig)(jiraFieldKey, fieldData, affectedServicesFn, cmdbObjectsFn, labelsFn, proformaForm);
        }
        if (config) asyncConfigs[fieldId] = (0, $17ShZ.withLoadOptionsAnalytics)(config, (0, $4ZyLG.getSchemaKey)(jiraFieldKey, jiraFieldData), createAnalyticsEvent, errorUtils);
    });
    return asyncConfigs;
};
const $077fde3b52013cd0$export$92ae9fb02efd1f26 = (jiraFieldData, proformaForm)=>{
    const affectedServicesFn = (0, $1lJtA.useAffectedServices)();
    const cmdbObjectsFn = (0, $i1Yim.useCmdbObjects)();
    const labelsFn = (0, $2KwTs.useLabels)();
    const usersFn = (0, $jscd0.useUsers)();
    const usersConfiguredFn = (0, $1l3d7.useUsersConfigured)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    return (0, $bSJIT.useMemo)(()=>$077fde3b52013cd0$export$f78302df54eb22ff(proformaForm, jiraFieldData, affectedServicesFn, cmdbObjectsFn, labelsFn, usersFn, usersConfiguredFn, createAnalyticsEvent, errorUtils), [
        affectedServicesFn,
        cmdbObjectsFn,
        createAnalyticsEvent,
        errorUtils,
        jiraFieldData,
        labelsFn,
        proformaForm,
        usersConfiguredFn,
        usersFn
    ]);
};

});
parcelRegister("1lJtA", function(module, exports) {
$parcel$export(module.exports, "useAffectedServices", () => $7a56dff9e053ddb1$export$2a2e19ab30a4e987);

var $bSJIT = parcelRequire("bSJIT");

var $djGAV = parcelRequire("djGAV");
const $7a56dff9e053ddb1$export$2a2e19ab30a4e987 = ()=>{
    const { fetch: fetch } = (0, $djGAV.useAffectedServicesService)();
    return (0, $bSJIT.useCallback)(()=>({
            loadOptions: async (query)=>{
                const data = await fetch(query);
                return data.services.map((affectedService)=>({
                        value: affectedService.id,
                        label: affectedService.name
                    }));
            },
            defaultOptions: true
        }), [
        fetch
    ]);
};

});
parcelRegister("djGAV", function(module, exports) {
$parcel$export(module.exports, "useAffectedServicesService", () => $b39d058c3cc31e24$export$553cac1b05d3003);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $1TyDZ = parcelRequire("1TyDZ");
const $b39d058c3cc31e24$export$553cac1b05d3003 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const request = (0, $bSJIT.useCallback)((query)=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`/rest/service-registry-api/service?query=${encodeURIComponent(query)}`, {
            method: 'GET'
        }, createAnalyticsEvent, errorUtils), [
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});


parcelRegister("i1Yim", function(module, exports) {
$parcel$export(module.exports, "useCmdbObjects", () => $9968cf25e0d68b59$export$a606b0aec990790f);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $VnB4y = parcelRequire("VnB4y");

var $51XYw = parcelRequire("51XYw");

var $aRyDY = parcelRequire("aRyDY");

var $eYiok = parcelRequire("eYiok");

var $bIf7w = parcelRequire("bIf7w");

var $42jvE = parcelRequire("42jvE");
const $9968cf25e0d68b59$export$a606b0aec990790f = ()=>{
    const { error: error, fetch: fetch } = (0, $aRyDY.useCmdbObjectsService)();
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    (0, $bSJIT.useEffect)(()=>{
        if (error instanceof (0, $51XYw.FetchError) && error.status === 400) showFlag({
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $bIf7w.messages).searchErrorDescription),
            isAutoDismiss: true,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $bIf7w.messages).searchErrorTitle),
            appearance: 'error'
        });
    }, [
        error,
        showFlag
    ]);
    return (0, $bSJIT.useCallback)((jiraFieldKey, filterAttributes, proformaForm)=>{
        // TODO: REQIN-4790 — Replace displayLabel with an optionComponent in AsyncFieldConfiguration
        // to keep CMDB rendering concerns out of the generic platform FormOptionsType type.
        // Design doc: https://hello.atlassian.net/wiki/spaces/FORMS/pages/7117590146
        const mapChoices = (choices)=>choices.results.map((choice)=>{
                const visibleAttributes = (0, $42jvE.getVisibleAttributes)(choice.attributes, filterAttributes);
                const [primaryAttribute, ...secondaryAttributes] = visibleAttributes;
                const secondaryAttributesDescription = (0, $42jvE.createAttributeString)(secondaryAttributes);
                return {
                    label: choice.label,
                    value: choice.id,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eYiok.CmdbIcon), {
                        ...choice.avatar.mediaClientConfig,
                        iconUrl: choice.avatar.url48
                    }),
                    byline: secondaryAttributesDescription,
                    displayLabel: primaryAttribute ? (0, $42jvE.createAttributeString)([
                        primaryAttribute
                    ]) : choice.label
                };
            });
        return {
            // TODO: Update useCmdbDefaults to use loadPaginatedOptions, then remove loadOptions.
            loadOptions: async (query, currentValues)=>{
                return fetch({
                    currentValues: currentValues,
                    jiraFieldKey: jiraFieldKey,
                    proformaForm: proformaForm,
                    query: query,
                    start: 0
                }).then(mapChoices);
            },
            loadPaginatedOptions: async (query, currentValues, _fieldId, start)=>{
                const choices = await fetch({
                    currentValues: currentValues,
                    jiraFieldKey: jiraFieldKey,
                    proformaForm: proformaForm,
                    query: query,
                    start: start
                });
                return {
                    options: mapChoices(choices),
                    hasNextPage: choices.hasNextPage
                };
            }
        };
    }, [
        fetch
    ]);
};

});
parcelRegister("aRyDY", function(module, exports) {
$parcel$export(module.exports, "useCmdbObjectsService", () => $f9efaae913437790$export$dffbc5f848cd795c);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $jxaMo = parcelRequire("jxaMo");
const $f9efaae913437790$export$dffbc5f848cd795c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const projectId = (0, $9OtAk.useProjectId)();
    const reporterAccountId = (0, $9OtAk.useReporterAccountId)();
    const requestTypeId = (0, $9OtAk.useRequestTypeId)();
    const request = (0, $bSJIT.useCallback)(({ currentValues: currentValues, jiraFieldKey: jiraFieldKey, proformaForm: proformaForm, query: query, start: start = 0 })=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`/rest/servicedesk/cmdb/1/customer/proforma/field/${jiraFieldKey}/autocomplete?start=${start}`, {
            method: 'POST',
            body: (0, $jxaMo.requestBody)(projectId, requestTypeId, currentValues, proformaForm, query, reporterAccountId)
        }, createAnalyticsEvent, errorUtils, 'json', 'cmdbAutocomplete'), [
        projectId,
        reporterAccountId,
        requestTypeId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});
parcelRegister("jxaMo", function(module, exports) {
$parcel$export(module.exports, "requestBody", () => $ad4e497ec302c920$export$e27faf208a9c3b58);

var $i86qj = parcelRequire("i86qj");

var $dS4H4 = parcelRequire("dS4H4");
const $ad4e497ec302c920$export$e27faf208a9c3b58 = (projectId, requestTypeId, currentValues, proformaForm, query, reporterAccountId)=>{
    return JSON.stringify({
        query: query,
        fieldValueMap: {
            ...reporterAccountId ? {
                reporter: reporterAccountId
            } : {},
            ...Object.fromEntries(Object.entries(currentValues).map(([fieldId, fieldValue])=>{
                const formQuestion = proformaForm.design.questions[fieldId];
                const jiraFieldId = formQuestion === null || formQuestion === void 0 ? void 0 : formQuestion.jiraField;
                return jiraFieldId ? [
                    jiraFieldId,
                    $ad4e497ec302c920$var$asContext(fieldValue, formQuestion)
                ] : [
                    undefined,
                    undefined
                ];
            }).filter(([_, fieldValue])=>fieldValue !== undefined)),
            pid: projectId.toString(),
            requesttype: requestTypeId.toString()
        }
    });
};
const $ad4e497ec302c920$var$asContext = (fieldValue, formQuestion)=>{
    var _asDateValue, _asLocalTimeValue, _asNumberValue, _asOptionsValue, _asTextValue;
    switch(formQuestion.type){
        case (0, $dS4H4.FormQuestionType).Date:
            return (_asDateValue = (0, $i86qj.asDateValue)(fieldValue)) === null || _asDateValue === void 0 ? void 0 : _asDateValue.date;
        case (0, $dS4H4.FormQuestionType).Time:
            return (_asLocalTimeValue = (0, $i86qj.asLocalTimeValue)(fieldValue)) === null || _asLocalTimeValue === void 0 ? void 0 : _asLocalTimeValue.localTime;
        case (0, $dS4H4.FormQuestionType).Number:
            return (_asNumberValue = (0, $i86qj.asNumberValue)(fieldValue)) === null || _asNumberValue === void 0 ? void 0 : _asNumberValue.number.toString();
        case (0, $dS4H4.FormQuestionType).ChoiceDropdown:
        case (0, $dS4H4.FormQuestionType).ChoiceDropdownMultiple:
        case (0, $dS4H4.FormQuestionType).ChoiceMultiple:
        case (0, $dS4H4.FormQuestionType).ChoiceSingle:
        case (0, $dS4H4.FormQuestionType).CmdbObject:
        case (0, $dS4H4.FormQuestionType).UserMultiple:
        case (0, $dS4H4.FormQuestionType).UserSingle:
            return (_asOptionsValue = (0, $i86qj.asOptionsValue)(fieldValue)) === null || _asOptionsValue === void 0 ? void 0 : _asOptionsValue.options.map((option)=>option.id).join(',');
        case (0, $dS4H4.FormQuestionType).TextEmail:
        case (0, $dS4H4.FormQuestionType).TextLong:
        case (0, $dS4H4.FormQuestionType).TextParagraph:
        case (0, $dS4H4.FormQuestionType).TextShort:
        case (0, $dS4H4.FormQuestionType).TextUrl:
            return (_asTextValue = (0, $i86qj.asTextValue)(fieldValue)) === null || _asTextValue === void 0 ? void 0 : _asTextValue.text;
        default:
            return undefined;
    }
};

});


parcelRegister("eYiok", function(module, exports) {
$parcel$export(module.exports, "CmdbIcon", () => $a3afaf1667fa6564$export$dd40f6e54a495f23);

var $bSJIT = parcelRequire("bSJIT");

var $JD7lD = parcelRequire("JD7lD");

var $10HUP = parcelRequire("10HUP");

var $bu3n5 = parcelRequire("bu3n5");

var $jUca3 = parcelRequire("jUca3");

var $gdUUy = parcelRequire("gdUUy");
const $a3afaf1667fa6564$var$IMAGE_SIZE = {
    width: 24,
    height: 24
};
const $a3afaf1667fa6564$var$mediaClientConfigs = new Map();
const $a3afaf1667fa6564$var$getMediaClientConfig = ({ mediaJwtToken: mediaJwtToken, clientId: clientId, mediaBaseUrl: mediaBaseUrl })=>{
    const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
    const existingMediaClientConfig = $a3afaf1667fa6564$var$mediaClientConfigs.get(key);
    if (existingMediaClientConfig) return existingMediaClientConfig;
    const mediaClientConfig = {
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: mediaJwtToken,
                baseUrl: mediaBaseUrl
            }),
        useSha256ForUploads: true
    };
    $a3afaf1667fa6564$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $a3afaf1667fa6564$var$hasAuth = ({ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, clientId: clientId })=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const $a3afaf1667fa6564$var$DefaultIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
        appearance: "square",
        size: "small"
    });
};
const $a3afaf1667fa6564$var$CmdbIconInternal = (props)=>{
    const { iconUrl: iconUrl } = props;
    if (!$a3afaf1667fa6564$var$hasAuth(props)) {
        if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
            src: iconUrl,
            appearance: "square",
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a3afaf1667fa6564$var$DefaultIcon, null);
    }
    const fileIdentifier = {
        id: props.fileId,
        mediaItemType: 'file'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bu3n5.MediaProvider), {
        mediaClientConfig: $a3afaf1667fa6564$var$getMediaClientConfig(props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jUca3.MediaImageWithErrorBoundary), {
        key: (0, $gdUUy.fg)('astral-assets-form-icon-fix') ? props.fileId : undefined,
        identifier: fileIdentifier,
        mediaClientConfig: $a3afaf1667fa6564$var$getMediaClientConfig(props),
        apiConfig: $a3afaf1667fa6564$var$IMAGE_SIZE
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $10HUP.default), {
            appearance: "square",
            size: "small"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a3afaf1667fa6564$var$DefaultIcon, null);
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a3afaf1667fa6564$var$DefaultIcon, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $JD7lD.default), {
            src: data.src,
            appearance: "square",
            size: "small",
            testId: "avatar"
        });
    }));
};
const $a3afaf1667fa6564$export$dd40f6e54a495f23 = /*#__PURE__*/ (0, $bSJIT.memo)($a3afaf1667fa6564$var$CmdbIconInternal);

});

parcelRegister("bIf7w", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8ce9ae1ef1d48d03$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $8ce9ae1ef1d48d03$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    searchErrorDescription: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.cmdb-objects.search-error-description',
        defaultMessage: 'Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid.',
        description: 'Error message informing the user that there was an error while fetching CMDB objects.'
    },
    searchErrorTitle: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.cmdb-objects.search-error-title',
        defaultMessage: "We couldn't fetch any objects for this field",
        description: 'Error title informing the user that there was an error while fetching CMDB objects.'
    }
});

});

parcelRegister("42jvE", function(module, exports) {
$parcel$export(module.exports, "getVisibleAttributes", () => $9e4e7c71713f764b$export$3c4337b649d4ffca);
$parcel$export(module.exports, "createAttributeString", () => $9e4e7c71713f764b$export$cd0f2f750043f4bc);
const $9e4e7c71713f764b$export$3c4337b649d4ffca = (attributes, attributesToDisplay)=>{
    const notUndefined = (attr)=>{
        return Boolean(attr);
    };
    return attributesToDisplay.map((attrName)=>attrName === 'Label' ? attributes.find((attr)=>attr.objectTypeAttribute.label) : attributes.find((attr)=>attr.objectTypeAttribute.name === attrName)).filter(notUndefined).filter((attribute)=>attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every((value)=>value && value.displayValue));
};
const $9e4e7c71713f764b$export$cd0f2f750043f4bc = (attributes)=>{
    return attributes.map((attribute)=>attribute.objectAttributeValues.map((value)=>value.displayValue).join(', ')).join(' | ');
};

});


parcelRegister("2KwTs", function(module, exports) {
$parcel$export(module.exports, "useLabels", () => $e42544f890acc8be$export$d6875122194c7b44);

var $bSJIT = parcelRequire("bSJIT");

var $k8Twv = parcelRequire("k8Twv");
const $e42544f890acc8be$export$9acfd79e4e151154 = /^\S+$/;
const $e42544f890acc8be$export$d6875122194c7b44 = ()=>{
    const { fetch: fetch } = (0, $k8Twv.useLabelsService)();
    return (0, $bSJIT.useCallback)((systemField, jiraFieldKey)=>{
        return {
            createOptions: {
                isValidNewOption: (input)=>$e42544f890acc8be$export$9acfd79e4e151154.test(input)
            },
            loadOptions: async (query)=>{
                let fetchArgument;
                if (systemField) fetchArgument = {
                    query: query
                };
                else {
                    const jiraFieldKeyParts = jiraFieldKey.split('_');
                    if (jiraFieldKeyParts.length !== 2) return Promise.reject(new Error(`Invalid Jira field key: ${jiraFieldKey}`));
                    fetchArgument = {
                        query: query,
                        customFieldId: jiraFieldKeyParts[1]
                    };
                }
                const data = await fetch(fetchArgument);
                return data.suggestions.map((jiraLabel)=>({
                        label: jiraLabel.label,
                        value: jiraLabel.label
                    }));
            },
            defaultOptions: true
        };
    }, [
        fetch
    ]);
};

});
parcelRegister("k8Twv", function(module, exports) {
$parcel$export(module.exports, "useLabelsService", () => $648b40518ced9e75$export$dab959054d284ed3);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $2MXlX = parcelRequire("2MXlX");
const $648b40518ced9e75$export$dab959054d284ed3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const portalId = (0, $9OtAk.usePortalId)();
    const requestTypeId = (0, $9OtAk.useRequestTypeId)();
    const request = (0, $bSJIT.useCallback)(({ customFieldId: customFieldId, query: query })=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`${(0, $2MXlX.JSM_CUSTOMER_PORTAL_URL_PREFIX)}/${portalId}/requestType/${requestTypeId}/labels/suggest?${customFieldId === undefined ? '' : `customFieldId=${customFieldId}&`}query=${encodeURIComponent(query)}`, {
            method: 'GET'
        }, createAnalyticsEvent, errorUtils), [
        portalId,
        requestTypeId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});


parcelRegister("jscd0", function(module, exports) {
$parcel$export(module.exports, "useUsers", () => $9926f71b83ad9320$export$90f4370c54dd43c9);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $5cYFn = parcelRequire("5cYFn");

var $tF5L8 = parcelRequire("tF5L8");
const $9926f71b83ad9320$export$90f4370c54dd43c9 = ()=>{
    const { fetch: fetch } = (0, $5cYFn.useUsersService)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return (0, $bSJIT.useCallback)(()=>({
            // Errors thrown here are silently caught by the FormRenderer's select components,
            // which call .catch(() => callback([])) — a failed fetch renders as an empty dropdown.
            // See: platform/packages/proforma/proforma-form-renderer/src/ui/form-renderer/form-sections/form-section/form-extension-renderer/form-field-renderer/single-select-input/edit/index.tsx L182-186
            // and the equivalent multiple-select-input/edit/index.tsx L182-186.
            loadOptions: async (query)=>{
                const users = await fetch(query);
                return users.map((user)=>({
                        value: user.accountId,
                        label: user.displayName ?? ''
                    }));
            },
            cacheOptions: true,
            noOptionsMessage: (input)=>{
                if (input !== null && input !== void 0 && input.inputValue) return formatMessage((0, $tF5L8.messages).noOptions);
                return formatMessage((0, $tF5L8.messages).startTyping);
            },
            defaultOptions: false
        }), [
        fetch,
        formatMessage
    ]);
};

});
parcelRegister("5cYFn", function(module, exports) {
$parcel$export(module.exports, "useUsersService", () => $5e5c9992f656cca4$export$27abced144ca7821);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $2MXlX = parcelRequire("2MXlX");
const $5e5c9992f656cca4$export$27abced144ca7821 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const serviceDeskId = (0, $9OtAk.useServiceDeskId)();
    const request = (0, $bSJIT.useCallback)((query)=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`${(0, $2MXlX.JSM_CUSTOMER_PORTAL_URL_PREFIX)}/${serviceDeskId}/user-search/proforma?query=${encodeURIComponent(query)}`, {
            method: 'GET'
        }, createAnalyticsEvent, errorUtils), [
        serviceDeskId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});

parcelRegister("tF5L8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $498579a1681b123b$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $498579a1681b123b$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    noOptions: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.users.no-options',
        defaultMessage: 'No options',
        description: 'Message informing the user that no options were found.'
    },
    startTyping: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.users.start-typing',
        defaultMessage: 'Start typing to search for users',
        description: 'Message informing the user to start typing to search for users.'
    }
});

});


parcelRegister("1l3d7", function(module, exports) {
$parcel$export(module.exports, "useUsersConfigured", () => $1293d4c67062f12a$export$a0ed4173e45bf37f);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $6oeuw = parcelRequire("6oeuw");

var $bgSJF = parcelRequire("bgSJF");
const $1293d4c67062f12a$export$a0ed4173e45bf37f = ()=>{
    const { fetch: fetch } = (0, $6oeuw.useUsersConfiguredService)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return (0, $bSJIT.useCallback)((jiraFieldKey, jiraFieldConfigId)=>({
            // Errors thrown here are silently caught by the FormRenderer's select components,
            // which call .catch(() => callback([])) — a failed fetch renders as an empty dropdown.
            // See: platform/packages/proforma/proforma-form-renderer/src/ui/form-renderer/form-sections/form-section/form-extension-renderer/form-field-renderer/single-select-input/edit/index.tsx L182-186
            // and the equivalent multiple-select-input/edit/index.tsx L182-186.
            loadOptions: async (query)=>{
                const users = await fetch({
                    jiraFieldKey: jiraFieldKey,
                    jiraFieldConfigId: jiraFieldConfigId,
                    query: query
                });
                return users.map((user)=>({
                        value: user.accountId,
                        label: user.displayName ?? ''
                    }));
            },
            cacheOptions: true,
            noOptionsMessage: (input)=>{
                if (input !== null && input !== void 0 && input.inputValue) return formatMessage((0, $bgSJF.messages).noOptions);
                return formatMessage((0, $bgSJF.messages).startTyping);
            },
            defaultOptions: false
        }), [
        fetch,
        formatMessage
    ]);
};

});
parcelRegister("6oeuw", function(module, exports) {
$parcel$export(module.exports, "useUsersConfiguredService", () => $90c91b4773cd590c$export$3d87912f569b072e);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $2MXlX = parcelRequire("2MXlX");
const $90c91b4773cd590c$export$3d87912f569b072e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const portalId = (0, $9OtAk.usePortalId)();
    const request = (0, $bSJIT.useCallback)(({ jiraFieldConfigId: jiraFieldConfigId, jiraFieldKey: jiraFieldKey, query: query })=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`${(0, $2MXlX.JSM_CUSTOMER_PORTAL_URL_PREFIX)}/${portalId}/user-search?fieldName=${jiraFieldKey}&fieldConfigId=${jiraFieldConfigId}&query=${encodeURIComponent(query)}`, {
            method: 'GET'
        }, createAnalyticsEvent, errorUtils), [
        portalId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});

parcelRegister("bgSJF", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2b7d823653b418b4$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2b7d823653b418b4$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    noOptions: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.users-configured.no-options',
        defaultMessage: 'No options',
        description: 'Message informing the user that no options were found.'
    },
    startTyping: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.async-fields.users-configured.start-typing',
        defaultMessage: 'Start typing to search for users',
        description: 'Message informing the user to start typing to search for users.'
    }
});

});


parcelRegister("4ZyLG", function(module, exports) {
$parcel$export(module.exports, "getSchemaKey", () => $93b903f985d94da9$export$599dd789035f4f6e);
const $93b903f985d94da9$export$599dd789035f4f6e = (jiraFieldKey, jiraFieldData)=>{
    var _fieldData$schema, _fieldData$schema2;
    if (!jiraFieldKey) return undefined;
    const fieldData = jiraFieldData.get(jiraFieldKey);
    return (fieldData === null || fieldData === void 0 || (_fieldData$schema = fieldData.schema) === null || _fieldData$schema === void 0 ? void 0 : _fieldData$schema.system) ?? (fieldData === null || fieldData === void 0 || (_fieldData$schema2 = fieldData.schema) === null || _fieldData$schema2 === void 0 ? void 0 : _fieldData$schema2.custom);
};

});

parcelRegister("cWpoJ", function(module, exports) {
$parcel$export(module.exports, "isUserField", () => $1d4f5ac70d6486dd$export$bb32d983dbd92725);

var $dS4H4 = parcelRequire("dS4H4");
const $1d4f5ac70d6486dd$export$bb32d983dbd92725 = (type)=>type === (0, $dS4H4.FormQuestionType).UserMultiple || type === (0, $dS4H4.FormQuestionType).UserSingle;

});

parcelRegister("4ZcCE", function(module, exports) {
$parcel$export(module.exports, "resolveSchemaConfig", () => $a9935426fcc0ad13$export$61ba4104febb2ee4);

var $hvu5b = parcelRequire("hvu5b");
const $a9935426fcc0ad13$export$61ba4104febb2ee4 = (jiraFieldKey, fieldData, affectedServicesFn, cmdbObjectsFn, labelsFn, proformaForm)=>{
    var _fieldData$schema, _fieldData$schema2;
    const customSchema = (_fieldData$schema = fieldData.schema) === null || _fieldData$schema === void 0 ? void 0 : _fieldData$schema.custom;
    const systemSchema = (_fieldData$schema2 = fieldData.schema) === null || _fieldData$schema2 === void 0 ? void 0 : _fieldData$schema2.system;
    if (systemSchema === (0, $hvu5b.LABELS_SCHEMA_SYSTEM)) return labelsFn(true, jiraFieldKey);
    if (customSchema === (0, $hvu5b.AFFECTED_SERVICES_SCHEMA_CUSTOM)) return affectedServicesFn();
    if (customSchema === (0, $hvu5b.CMDB_SCHEMA_CUSTOM) && fieldData.fieldConfigId !== undefined) return cmdbObjectsFn(jiraFieldKey, fieldData.attributes || [], proformaForm);
    if (customSchema === (0, $hvu5b.LABELS_SCHEMA_CUSTOM)) return labelsFn(false, jiraFieldKey);
    return undefined;
};

});
parcelRegister("hvu5b", function(module, exports) {
$parcel$export(module.exports, "AFFECTED_SERVICES_SCHEMA_CUSTOM", () => $eab972833399413b$export$f38b84edab004d9a);
$parcel$export(module.exports, "CMDB_SCHEMA_CUSTOM", () => $eab972833399413b$export$701618b68a89ad17);
$parcel$export(module.exports, "LABELS_SCHEMA_CUSTOM", () => $eab972833399413b$export$9af6b0504e2cd927);
$parcel$export(module.exports, "LABELS_SCHEMA_SYSTEM", () => $eab972833399413b$export$65f164d21923031);
const $eab972833399413b$export$f38b84edab004d9a = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $eab972833399413b$export$701618b68a89ad17 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $eab972833399413b$export$9af6b0504e2cd927 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $eab972833399413b$export$65f164d21923031 = 'labels';

});


parcelRegister("lrO5j", function(module, exports) {
$parcel$export(module.exports, "resolveUserConfig", () => $bbc31e204cc32bcf$export$6b2a6473cd16d897);
const $bbc31e204cc32bcf$export$6b2a6473cd16d897 = (jiraFieldKey, jiraFieldData, usersConfiguredFn, usersFn)=>{
    var _jiraFieldData$get;
    const jiraFieldConfigId = jiraFieldKey === undefined ? undefined : (_jiraFieldData$get = jiraFieldData.get(jiraFieldKey)) === null || _jiraFieldData$get === void 0 ? void 0 : _jiraFieldData$get.fieldConfigId;
    if (jiraFieldKey && jiraFieldConfigId) return usersConfiguredFn(jiraFieldKey, jiraFieldConfigId);
    return usersFn();
};

});

parcelRegister("17ShZ", function(module, exports) {
$parcel$export(module.exports, "withLoadOptionsAnalytics", () => $a75febc1ba5fd206$export$f2f09211bec238f3);

var $k2MWg = parcelRequire("k2MWg");

var $429NB = parcelRequire("429NB");
const $a75febc1ba5fd206$export$f2f09211bec238f3 = (config, schemaKey, createAnalyticsEvent, errorUtils)=>{
    const originalLoadOptions = config.loadOptions;
    if (!originalLoadOptions) return config;
    return {
        ...config,
        loadOptions: async (...args)=>{
            try {
                const result = await originalLoadOptions(...args);
                (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $429NB.ActionSubject).SEARCH_ASYNC_CHOICES} ${(0, $429NB.Action).FINISHED}`, {
                    schemaKey: schemaKey
                });
                return result;
            } catch (error) {
                errorUtils.reportError(error, {
                    id: (0, $429NB.ActionSubject).SEARCH_ASYNC_CHOICES,
                    attributes: {
                        schemaKey: schemaKey
                    }
                });
                throw error;
            }
        }
    };
};

});


parcelRegister("9aH4T", function(module, exports) {
$parcel$export(module.exports, "useAttachmentConfiguration", () => $82dc110e712527f2$export$457ceef4315cacf6);

var $bSJIT = parcelRequire("bSJIT");

var $9OtAk = parcelRequire("9OtAk");
const $82dc110e712527f2$export$457ceef4315cacf6 = ()=>{
    const { baseUrl: baseUrl, collection: collection, clientId: clientId, token: token } = (0, $9OtAk.useMediaUploadConfig)();
    // Store token in a ref so it can be refreshed and returned from the AuthProvider.
    // Media components cache the AuthProvider, so if we build a new AuthProvider which
    // returns a new token, the Media components will not use the updated token.
    const tokenRef = (0, $bSJIT.useRef)(token);
    (0, $bSJIT.useEffect)(()=>{
        tokenRef.current = token;
    }, [
        token
    ]);
    const attachmentConfiguration = (0, $bSJIT.useMemo)(()=>{
        // Return undefined if media config is not available (graceful degradation)
        if (!baseUrl || !clientId) return undefined;
        return {
            // Read config is needed to display thumbnails of newly uploaded files.
            // Uses the same credentials as upload since files are in the same collection.
            read: {
                mediaClientConfig: {
                    authProvider: ()=>Promise.resolve({
                            baseUrl: baseUrl,
                            clientId: clientId,
                            token: tokenRef.current
                        })
                }
            },
            upload: {
                mediaClientConfig: {
                    authProvider: ()=>Promise.resolve({
                            baseUrl: baseUrl,
                            clientId: clientId,
                            token: tokenRef.current
                        })
                },
                mediaBrowserConfig: {
                    multiple: true,
                    uploadParams: {
                        collection: collection
                    }
                },
                mediaDropzoneConfig: {
                    uploadParams: {
                        collection: collection
                    }
                }
            }
        };
    }, [
        baseUrl,
        clientId,
        collection
    ]);
    return attachmentConfiguration;
};

});

parcelRegister("kZukY", function(module, exports) {
$parcel$export(module.exports, "useAttachmentUploadEnd", () => $9a2b27f6806bc0e5$export$e98febab2f0ebfb3);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $87QgR = parcelRequire("87QgR");

var $VnB4y = parcelRequire("VnB4y");

var $k2MWg = parcelRequire("k2MWg");

var $51XYw = parcelRequire("51XYw");

var $9z85g = parcelRequire("9z85g");

var $429NB = parcelRequire("429NB");

var $4OAp3 = parcelRequire("4OAp3");

var $3YxAL = parcelRequire("3YxAL");
const $9a2b27f6806bc0e5$var$ATTACHMENT_REGISTRY_FIX_GATE = 'proforma-jsdcloud-19146-attachment-registry-fix';
const $9a2b27f6806bc0e5$var$isAttachmentRegistryFixEnabled = ()=>(0, $87QgR.default).checkGate($9a2b27f6806bc0e5$var$ATTACHMENT_REGISTRY_FIX_GATE);
const $9a2b27f6806bc0e5$export$e98febab2f0ebfb3 = ()=>{
    const { showFlag: showFlag } = (0, $VnB4y.useFlags)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { fetch: fetch, error: error } = (0, $4OAp3.useRegisterAsTemporaryAttachmentService)();
    const manageAttachmentRegistration = (0, $9z85g.useManageAttachmentRegistration)();
    (0, $bSJIT.useEffect)(()=>{
        if (!error) return;
        const showErrorFlag = ()=>{
            let description = formatMessage((0, $3YxAL.messages).uploadErrorDescription);
            if (error instanceof (0, $51XYw.FetchError) && error.status === 400) {
                if (error.message) description = error.message;
            }
            showFlag({
                description: description,
                title: formatMessage((0, $3YxAL.messages).uploadError),
                appearance: 'error'
            });
        };
        showErrorFlag();
    }, [
        error,
        showFlag,
        formatMessage
    ]);
    return (0, $bSJIT.useCallback)((uploadEndPayload)=>{
        const fileId = uploadEndPayload.file.identifier.id;
        // Behind the gate the shared hook keeps the field blocked while registering and removes the
        // file on failure; without it we just register. Either way we fire FINISHED/FAILED analytics
        // so the registration step is monitored regardless of the gate. The handler is fire-and-forget
        // (returns void) because the renderer's lifecycle handler slot expects a void return.
        const registration = $9a2b27f6806bc0e5$var$isAttachmentRegistryFixEnabled() ? manageAttachmentRegistration(uploadEndPayload, ()=>fetch({
                fileId: fileId
            })) : fetch({
            fileId: fileId
        });
        registration.then(()=>{
            (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $429NB.ActionSubject).UPLOAD_ISSUE_FORM_ATTACHMENTS} ${(0, $429NB.Action).FINISHED}`, {
                fileId: fileId
            });
        }).catch((registrationError)=>{
            // The error flag is surfaced by the effect above which reacts to the service `error` state.
            (0, $k2MWg.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $429NB.ActionSubject).UPLOAD_ISSUE_FORM_ATTACHMENTS} ${(0, $429NB.Action).FAILED}`, {
                fileId: fileId,
                failureType: 'attachmentRegistration',
                ...(0, $9z85g.getRegistrationErrorAttributes)(registrationError)
            });
        });
    }, [
        fetch,
        manageAttachmentRegistration,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("4OAp3", function(module, exports) {
$parcel$export(module.exports, "useRegisterAsTemporaryAttachmentService", () => $f4d84249edb4e6d3$export$eb19a05ccdc0773e);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $bWiRx = parcelRequire("bWiRx");

var $fyqAM = parcelRequire("fyqAM");

var $9OtAk = parcelRequire("9OtAk");

var $1TyDZ = parcelRequire("1TyDZ");

var $2MXlX = parcelRequire("2MXlX");
const $f4d84249edb4e6d3$export$eb19a05ccdc0773e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const errorUtils = (0, $fyqAM.usePfErrorUtils)();
    const portalId = (0, $9OtAk.usePortalId)();
    const request = (0, $bSJIT.useCallback)(({ fileId: fileId })=>(0, $1TyDZ.proformaGasAnalyticsFetch)(`${(0, $2MXlX.JSM_CUSTOMER_PORTAL_URL_PREFIX)}/${portalId}/media/upload`, {
            method: 'POST',
            body: JSON.stringify({
                fileId: fileId
            })
        }, createAnalyticsEvent, errorUtils), [
        portalId,
        createAnalyticsEvent,
        errorUtils
    ]);
    return (0, $bWiRx.useService)(request);
};

});

parcelRegister("3YxAL", function(module, exports) {
$parcel$export(module.exports, "messages", () => $861ba84dead4eba8$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $861ba84dead4eba8$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    uploadError: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.attachment-lifecycle-handlers.upload-error',
        defaultMessage: 'Error uploading attachment',
        description: 'Message for when an error occurs during attachment upload'
    },
    uploadErrorDescription: {
        id: 'proforma.request-create.ui.proforma-request-create.utils.attachment-lifecycle-handlers.upload-error-description',
        defaultMessage: 'An error occurred when uploading an attachment',
        description: 'Description on flag for when an error occurs during an attachment upload'
    }
});

});


parcelRegister("63xql", function(module, exports) {
$parcel$export(module.exports, "useCmdbDefaults", () => $bc5e84a644302b93$export$5144028bf5908e49);

var $4ZMmh = parcelRequire("4ZMmh");

var $bSJIT = parcelRequire("bSJIT");

var $5JwFL = parcelRequire("5JwFL");

var $9OtAk = parcelRequire("9OtAk");

var $i1Yim = parcelRequire("i1Yim");

var $hvu5b = parcelRequire("hvu5b");
const $bc5e84a644302b93$export$5144028bf5908e49 = (proformaForm)=>{
    const reporterAccountId = (0, $9OtAk.useReporterAccountId)();
    const cmdbObjectsAsyncFieldConfiguration = (0, $i1Yim.useCmdbObjects)();
    const jiraFieldData = (0, $9OtAk.useJiraFieldData)();
    const { getFieldValues: getFieldValues, updateModifiedValue: updateModifiedValue } = (0, $5JwFL.usePublicFormRendererActions)();
    const refreshCounterRef = (0, $bSJIT.useRef)({});
    const previousReporterAccountIdRef = (0, $bSJIT.useRef)();
    const standaloneAlreadyPopulatedRef = (0, $bSJIT.useRef)(new Set());
    (0, $bSJIT.useEffect)(()=>{
        $bc5e84a644302b93$export$d6b70feb642bb45({
            proformaForm: proformaForm,
            jiraFieldData: jiraFieldData,
            cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration,
            getFieldValues: getFieldValues,
            updateModifiedValue: updateModifiedValue,
            refreshCounterRef: refreshCounterRef,
            alreadyPopulatedRef: standaloneAlreadyPopulatedRef
        }).catch((0, $4ZMmh.noop));
    }, [
        cmdbObjectsAsyncFieldConfiguration,
        getFieldValues,
        jiraFieldData,
        proformaForm,
        updateModifiedValue
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (previousReporterAccountIdRef.current === reporterAccountId) return;
        previousReporterAccountIdRef.current = reporterAccountId;
        $bc5e84a644302b93$export$8b9b23c7fe0a450c({
            getFieldValues: getFieldValues,
            updateModifiedValue: updateModifiedValue,
            cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration,
            jiraFieldData: jiraFieldData,
            refreshCounterRef: refreshCounterRef,
            proformaForm: proformaForm,
            jiraFieldKeyOfChangedField: 'reporter'
        }).catch((0, $4ZMmh.noop));
    }, [
        cmdbObjectsAsyncFieldConfiguration,
        getFieldValues,
        jiraFieldData,
        proformaForm,
        reporterAccountId,
        updateModifiedValue
    ]);
    const onFieldChanged = (0, $bSJIT.useCallback)((event)=>{
        $bc5e84a644302b93$export$8b9b23c7fe0a450c({
            getFieldValues: getFieldValues,
            updateModifiedValue: updateModifiedValue,
            cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration,
            jiraFieldData: jiraFieldData,
            refreshCounterRef: refreshCounterRef,
            proformaForm: proformaForm,
            jiraFieldKeyOfChangedField: $bc5e84a644302b93$var$getJiraFieldKey(event.fieldId, proformaForm)
        }).catch((0, $4ZMmh.noop));
    }, [
        cmdbObjectsAsyncFieldConfiguration,
        getFieldValues,
        jiraFieldData,
        proformaForm,
        updateModifiedValue
    ]);
    return {
        onFieldChanged: onFieldChanged
    };
};
const $bc5e84a644302b93$export$d6b70feb642bb45 = async ({ proformaForm: proformaForm, jiraFieldData: jiraFieldData, cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration, getFieldValues: getFieldValues, updateModifiedValue: updateModifiedValue, refreshCounterRef: refreshCounterRef, alreadyPopulatedRef: alreadyPopulatedRef })=>{
    const standaloneCmdbFields = $bc5e84a644302b93$var$getStandaloneCmdbFields(proformaForm, jiraFieldData).filter(({ fieldId: fieldId })=>!alreadyPopulatedRef.current.has(fieldId));
    if (standaloneCmdbFields.length === 0) return;
    // Mark before awaiting so concurrent invocations of this effect (e.g. from a
    // dependency-identity change before the first run resolves) do not double-fire.
    standaloneCmdbFields.forEach(({ fieldId: fieldId })=>alreadyPopulatedRef.current.add(fieldId));
    const fieldValues = getFieldValues();
    await Promise.allSettled(standaloneCmdbFields.map(async ({ fieldId: fieldId, jiraFieldKey: jiraFieldKey, issueFieldData: issueFieldData, question: question })=>{
        const refreshRequestId = $bc5e84a644302b93$var$nextCmdbRefreshRequestId(fieldId, refreshCounterRef);
        const defaultOptions = await $bc5e84a644302b93$var$getCmdbFieldDefaultOptions({
            proformaForm: proformaForm,
            cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration,
            fieldId: fieldId,
            jiraFieldKey: jiraFieldKey,
            issueFieldData: issueFieldData,
            fieldValues: fieldValues
        });
        const limitedOptions = $bc5e84a644302b93$var$getLimitedOptions(defaultOptions, question, issueFieldData);
        if (!$bc5e84a644302b93$var$isCmdbRefreshStale(fieldId, refreshRequestId, refreshCounterRef) && limitedOptions.length > 0) $bc5e84a644302b93$var$applyCmdbDefaultOptions(fieldId, limitedOptions, updateModifiedValue);
    }));
};
const $bc5e84a644302b93$var$getStandaloneCmdbFields = (proformaForm, jiraFieldData)=>Object.entries(proformaForm.design.questions).map(([fieldId, question])=>{
        var _issueFieldData$schem, _issueFieldData$depen;
        const jiraFieldKey = question.jiraField;
        if (!jiraFieldKey) return null;
        const issueFieldData = jiraFieldData.get(jiraFieldKey);
        if (!issueFieldData || ((_issueFieldData$schem = issueFieldData.schema) === null || _issueFieldData$schem === void 0 ? void 0 : _issueFieldData$schem.custom) !== (0, $hvu5b.CMDB_SCHEMA_CUSTOM) || issueFieldData.populateDefaultValueOnEmptySearch !== true || (((_issueFieldData$depen = issueFieldData.dependsOn) === null || _issueFieldData$depen === void 0 ? void 0 : _issueFieldData$depen.length) ?? 0) > 0) return null;
        return {
            fieldId: fieldId,
            jiraFieldKey: jiraFieldKey,
            question: question,
            issueFieldData: issueFieldData
        };
    }).filter((field)=>field !== null);
const $bc5e84a644302b93$export$8b9b23c7fe0a450c = async ({ jiraFieldKeyOfChangedField: jiraFieldKeyOfChangedField, proformaForm: proformaForm, jiraFieldData: jiraFieldData, getFieldValues: getFieldValues, updateModifiedValue: updateModifiedValue, refreshCounterRef: refreshCounterRef, cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration })=>{
    const allDependentCmdbFields = jiraFieldKeyOfChangedField ? $bc5e84a644302b93$var$getDependentCmdbFields(jiraFieldKeyOfChangedField, proformaForm, jiraFieldData) : [];
    if ($bc5e84a644302b93$var$shouldSkipCmdbRefresh({
        dependentCmdbFields: allDependentCmdbFields
    })) return;
    // Skip only the dependent CMDB fields that sit in a `dependsOn` cycle which passes through the
    // changed field itself (e.g. changedField -> ... -> field -> changedField). Refreshing such a
    // field has no well-defined order — it would clear/recompute a value that the changed field
    // (transitively) depends on, which could in turn re-trigger this very refresh. Non-cyclic
    // dependents are still refreshed below; any further fields down their chains are handled by the
    // refresh those updates recursively trigger.
    const dependentCmdbFieldsWithoutCircularDependency = jiraFieldKeyOfChangedField ? allDependentCmdbFields.filter(({ jiraFieldKey: dependentJiraFieldKey })=>!$bc5e84a644302b93$var$isFieldInCycleWithChangedField(dependentJiraFieldKey, jiraFieldKeyOfChangedField, jiraFieldData)) : allDependentCmdbFields;
    if (dependentCmdbFieldsWithoutCircularDependency.length === 0) return;
    const fieldValuesSnapshot = getFieldValues();
    const fieldValuesExcludingDependentCmdb = $bc5e84a644302b93$var$createFieldValuesForDependentCmdbFieldsRefresh(fieldValuesSnapshot, dependentCmdbFieldsWithoutCircularDependency);
    await Promise.allSettled(dependentCmdbFieldsWithoutCircularDependency.map(async ({ fieldId: fieldId, jiraFieldKey: jiraFieldKey, issueFieldData: issueFieldData, question: question })=>{
        const refreshRequestId = $bc5e84a644302b93$var$nextCmdbRefreshRequestId(fieldId, refreshCounterRef);
        $bc5e84a644302b93$var$clearCmdbField(fieldId, updateModifiedValue);
        const defaultOptions = await $bc5e84a644302b93$var$getCmdbFieldDefaultOptions({
            proformaForm: proformaForm,
            cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration,
            fieldId: fieldId,
            jiraFieldKey: jiraFieldKey,
            issueFieldData: issueFieldData,
            // When the parent field changes, the dependent CMDB fields' current values are now potentially stale.
            // If those stale child values were left inside `currentValues`, the backend request would still include
            // them in `fieldValueMap`, which could make the refresh depend on the very values that are supposed to
            // be recomputed. So we omit them to make the request mean:
            // "Recalculate defaults using the parent/upstream context, but pretend the dependent CMDB children are currently blank."
            fieldValues: fieldValuesExcludingDependentCmdb
        });
        const limitedOptions = $bc5e84a644302b93$var$getLimitedOptions(defaultOptions, question, issueFieldData);
        if (!$bc5e84a644302b93$var$isCmdbRefreshStale(fieldId, refreshRequestId, refreshCounterRef) && limitedOptions.length > 0) $bc5e84a644302b93$var$applyCmdbDefaultOptions(fieldId, limitedOptions, updateModifiedValue);
    }));
};
const $bc5e84a644302b93$var$getLimitedOptions = (defaultOptions, question, issueFieldData)=>{
    const limitedOptions = defaultOptions.slice(0, $bc5e84a644302b93$var$getMaxSelectableCmdbOptions(question, issueFieldData, defaultOptions.length));
    return limitedOptions;
};
const $bc5e84a644302b93$var$getJiraFieldKey = (fieldId, proformaForm)=>{
    var _proformaForm$design$;
    return (_proformaForm$design$ = proformaForm.design.questions[fieldId]) === null || _proformaForm$design$ === void 0 ? void 0 : _proformaForm$design$.jiraField;
};
const $bc5e84a644302b93$var$getDependentCmdbFields = (changedJiraFieldKey, proformaForm, jiraFieldData)=>Object.entries(proformaForm.design.questions).map(([fieldId, question])=>{
        var _issueFieldData$schem2, _issueFieldData$depen2;
        const jiraFieldKey = question.jiraField;
        if (!jiraFieldKey) return null;
        const issueFieldData = jiraFieldData.get(jiraFieldKey);
        if (!issueFieldData || ((_issueFieldData$schem2 = issueFieldData.schema) === null || _issueFieldData$schem2 === void 0 ? void 0 : _issueFieldData$schem2.custom) !== (0, $hvu5b.CMDB_SCHEMA_CUSTOM) || !((_issueFieldData$depen2 = issueFieldData.dependsOn) !== null && _issueFieldData$depen2 !== void 0 && _issueFieldData$depen2.includes(changedJiraFieldKey))) return null;
        return {
            fieldId: fieldId,
            jiraFieldKey: jiraFieldKey,
            question: question,
            issueFieldData: issueFieldData
        };
    }).filter((field)=>field !== null);
const $bc5e84a644302b93$var$createFieldValuesForDependentCmdbFieldsRefresh = (currentValues, dependentCmdbFields)=>{
    const excludedFieldIds = new Set(dependentCmdbFields.map(({ fieldId: fieldId })=>fieldId));
    return Object.fromEntries(Object.entries(currentValues).filter(([fieldId])=>!excludedFieldIds.has(fieldId)));
};
const $bc5e84a644302b93$var$getCmdbFieldDefaultOptions = async ({ proformaForm: proformaForm, cmdbObjectsAsyncFieldConfiguration: cmdbObjectsAsyncFieldConfiguration, fieldId: fieldId, jiraFieldKey: jiraFieldKey, issueFieldData: issueFieldData, fieldValues: fieldValues })=>{
    var _config$loadOptions;
    if (!issueFieldData.populateDefaultValueOnEmptySearch) return [];
    const config = cmdbObjectsAsyncFieldConfiguration(jiraFieldKey, issueFieldData.attributes ?? [], proformaForm);
    // A call to loadOptions with these arguments effectively says:
    // "Given the current form context, and no typed search query (as changing the parent should erase existing search strings in the child so a default can be shown),
    // what CMDB options/defaults should this field have now?"
    // The empty string is important: this is a default, not a user search.
    const defaultOptions = await ((_config$loadOptions = config.loadOptions) === null || _config$loadOptions === void 0 ? void 0 : _config$loadOptions.call(config, '', fieldValues, fieldId)) ?? [];
    return defaultOptions.map($bc5e84a644302b93$var$mapCmdbDefaultSelectOptionToFormOptionValue);
};
const $bc5e84a644302b93$var$getMaxSelectableCmdbOptions = (question, issueFieldData, availableOptionsCount)=>{
    const defaultLimit = issueFieldData.multiple === false ? 1 : availableOptionsCount;
    const validationLimit = question.validation.mxs ?? defaultLimit;
    const fieldDataLimit = issueFieldData.maxAllowedChoices ?? defaultLimit;
    return Math.min(defaultLimit, validationLimit, fieldDataLimit);
};
const $bc5e84a644302b93$var$mapCmdbDefaultSelectOptionToFormOptionValue = ({ avatar: avatar, byline: byline, label: label, value: value })=>({
        label: label,
        id: String(value),
        ...avatar !== undefined ? {
            avatar: avatar
        } : {},
        ...byline !== undefined ? {
            byline: byline
        } : {}
    });
/** Increments the per-field refresh generation and returns the id for this in-flight request. */ const $bc5e84a644302b93$var$nextCmdbRefreshRequestId = (fieldId, refreshCounterRef)=>{
    const refreshRequestId = (refreshCounterRef.current[fieldId] ?? 0) + 1;
    refreshCounterRef.current[fieldId] = refreshRequestId;
    return refreshRequestId;
};
/** True if a newer refresh has started for this field since `refreshRequestId` was issued. */ const $bc5e84a644302b93$var$isCmdbRefreshStale = (fieldId, refreshRequestId, refreshCounterRef)=>refreshCounterRef.current[fieldId] !== refreshRequestId;
const $bc5e84a644302b93$var$clearCmdbField = (fieldId, updateModifiedValue)=>{
    updateModifiedValue(fieldId, null);
};
/** Caller must ensure this refresh is still current and `options` is non-empty. */ const $bc5e84a644302b93$var$applyCmdbDefaultOptions = (fieldId, options, updateModifiedValue)=>{
    updateModifiedValue(fieldId, {
        options: options
    });
};
const $bc5e84a644302b93$var$shouldSkipCmdbRefresh = ({ dependentCmdbFields: dependentCmdbFields })=>{
    if (dependentCmdbFields.length === 0) // Most field changes do not affect CMDB children, so skip clearing answers and avoid a pointless empty-search refresh.
    return true;
    return false;
};
/**
 * Determines whether a dependent CMDB field sits in a `dependsOn` cycle that passes through the
 * field the user just changed.
 *
 * The relationships form a directed graph over Jira field keys, where each field key has an outgoing
 * edge to every key listed in its `IssueFieldData.dependsOn` array.
 *
 * We assume that `dependentJiraFieldKey` already has a direct dependency on `changedJiraFieldKey`, i.e. an edge
 * `dependentJiraFieldKey -> changedJiraFieldKey` exists. Such a field participates in a cycle *with* the
 * changed field precisely when the changed field can also reach it, i.e. there is a path
 * `changedJiraFieldKey -> ... -> dependentJiraFieldKey`. Combined with the known reverse edge, that
 * forms the cycle `changedJiraFieldKey -> ... -> dependentJiraFieldKey -> changedJiraFieldKey`.
 *
 * The cycle can be direct (changed -> field -> changed) or span multiple hops
 * (changed -> X -> field -> changed). Edges pointing at Jira field keys that have no
 * `IssueFieldData` entry (e.g. `reporter`, or a parent not part of this form) are treated as leaves.
 *
 * Reachability is computed with an iterative depth-first search (explicit stack) so that a large or
 * deeply nested graph cannot overflow the call stack.
 */ const $bc5e84a644302b93$var$isFieldInCycleWithChangedField = (dependentJiraFieldKey, changedJiraFieldKey, jiraFieldData)=>{
    const getDependsOn = (jiraFieldKey)=>{
        var _jiraFieldData$get;
        return ((_jiraFieldData$get = jiraFieldData.get(jiraFieldKey)) === null || _jiraFieldData$get === void 0 ? void 0 : _jiraFieldData$get.dependsOn) ?? [];
    };
    // Walk forward from the changed field; if we can reach the dependent field, the two are mutually
    // reachable and therefore share a cycle.
    // fieldsToVisit - contains the list of Jira field keys to explore next for reachability
    // visitedFields - contains the list of Jira field keys that have already been explored for reachability
    const fieldsToVisit = [
        ...getDependsOn(changedJiraFieldKey)
    ];
    const visitedFields = new Set([
        changedJiraFieldKey
    ]);
    while(fieldsToVisit.length > 0){
        const currentJiraFieldKey = fieldsToVisit.pop();
        if (currentJiraFieldKey === dependentJiraFieldKey) return true;
        if (currentJiraFieldKey !== undefined && !visitedFields.has(currentJiraFieldKey)) {
            visitedFields.add(currentJiraFieldKey);
            fieldsToVisit.push(...getDependsOn(currentJiraFieldKey));
        }
    }
    return false;
};

});

parcelRegister("fUCfn", function(module, exports) {
$parcel$export(module.exports, "buildFormViewedAnalyticsAttributes", () => $39963138b99a9c35$export$da9f7ee7fc6976e7);
/* oxlint-disable no-nested-ternary */ const $39963138b99a9c35$export$fc6800ebf988f90 = (linkedSummaryQuestionId, docNodes)=>(docNodes === null || docNodes === void 0 ? void 0 : docNodes.some((node)=>node.content.some((contentItem)=>{
            var _contentItem$attrs;
            return contentItem.type === 'extension' && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            ((_contentItem$attrs = contentItem.attrs) === null || _contentItem$attrs === void 0 || (_contentItem$attrs = _contentItem$attrs.parameters) === null || _contentItem$attrs === void 0 ? void 0 : _contentItem$attrs.id) === linkedSummaryQuestionId;
        }))) ?? false;
function $39963138b99a9c35$export$da9f7ee7fc6976e7(proformaForm, locale) {
    const { design: design } = proformaForm;
    const { settings: settings, layout: layout, questions: questions } = design;
    const { translatedLocale: translatedLocale, primaryLocale: primaryLocale, language: language } = settings;
    const formId = proformaForm.id;
    const linkedSummaryQuestionId = Object.entries(questions).find(([_, question])=>question.jiraField === 'summary');
    const hasLinkedSummary = Boolean(linkedSummaryQuestionId);
    const summaryOnTopLevel = linkedSummaryQuestionId ? $39963138b99a9c35$export$fc6800ebf988f90(Number(linkedSummaryQuestionId[0]), layout) : false;
    const displayLocale = translatedLocale != null ? translatedLocale : primaryLocale != null ? primaryLocale : language != null ? language : locale;
    const translationDetails = {
        primaryLocale: primaryLocale,
        translatedLocale: translatedLocale,
        legacyLanguage: language != null ? language.replace('_', '-') : undefined,
        localeMatched: displayLocale === locale,
        translated: translatedLocale !== primaryLocale,
        translationsApplied: translatedLocale !== undefined,
        userLocale: locale
    };
    return {
        hasLinkedSummary: hasLinkedSummary,
        summaryOnTopLevel: summaryOnTopLevel,
        translationDetails: translationDetails,
        formId: formId
    };
}

});

parcelRegister("9U9T0", function(module, exports) {
$parcel$export(module.exports, "useFormikRegisterProformaForm", () => $1d68a219d7534246$export$e7699aef25caafd0);
$parcel$export(module.exports, "useFormikFieldErrors", () => $1d68a219d7534246$export$342ba682679145b9);
$parcel$export(module.exports, "useFormikBlockSubmissionDuringUpload", () => $1d68a219d7534246$export$4668d6b615699b79);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $k2MWg = parcelRequire("k2MWg");

var $82gbm = parcelRequire("82gbm");

var $5JwFL = parcelRequire("5JwFL");

var $9syXG = parcelRequire("9syXG");

var $429NB = parcelRequire("429NB");

var $fuhuQ = parcelRequire("fuhuQ");

var $9OtAk = parcelRequire("9OtAk");
const $1d68a219d7534246$export$e7699aef25caafd0 = (forms)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { getFieldIdsFailingValidation: getFieldIdsFailingValidation, getVisibleFieldValues: getVisibleFieldValues } = (0, $5JwFL.usePublicFormRendererActions)();
    const registerProformaForm = (0, $9OtAk.useRegisterProformaForm)();
    const setValidationFieldSet = (0, $9OtAk.useSetValidationFieldSet)();
    // Validates the form and returns validity via callback
    const validateProformaForm = (0, $bSJIT.useCallback)((callback)=>{
        var _forms$proformaForm$p;
        // The portal and Jira publish settings are kept in sync by the backend; prefer portal here.
        const portalPublishing = (_forms$proformaForm$p = forms.proformaForm.publish) === null || _forms$proformaForm$p === void 0 ? void 0 : _forms$proformaForm$p.portal;
        if (portalPublishing === undefined) {
            // Mirror the Jira consumer: without publish config we cannot proceed.
            callback(false);
            return;
        }
        const { validateOnCreate: validateOnCreate } = portalPublishing;
        if (validateOnCreate) setValidationFieldSet((0, $82gbm.ValidationFieldSet).ALL_FIELDS);
        else if (getFieldIdsFailingValidation({
            fieldSet: (0, $82gbm.ValidationFieldSet).SECURITY_CRITICAL
        }).length > 0) {
            setValidationFieldSet((0, $82gbm.ValidationFieldSet).SECURITY_CRITICAL);
            callback(false);
            return;
        }
        callback(!validateOnCreate || getFieldIdsFailingValidation({
            fieldSet: (0, $82gbm.ValidationFieldSet).ALL_FIELDS
        }).length === 0);
    }, [
        forms.proformaForm,
        getFieldIdsFailingValidation,
        setValidationFieldSet
    ]);
    // Converts FormRenderer field values to the `SerializedProformaFormData` format
    const serializeProformaForm = (0, $bSJIT.useCallback)((callback)=>{
        const visibleValues = getVisibleFieldValues();
        const answers = (0, $9syXG.convertValuesToFormAnswers)(visibleValues, forms.proformaForm.design.questions);
        const serializedFormData = {
            answers: answers,
            templateFormId: forms.proformaForm.design.settings.templateId,
            visibleFieldCount: Object.keys(visibleValues ?? {}).length
        };
        callback(serializedFormData);
        (0, $k2MWg.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $429NB.ActionSubject).FORM} ${(0, $429NB.Action).CREATED}`, (0, $fuhuQ.buildFormCreatedAnalyticsAttributes)(forms.proformaForm));
    }, [
        createAnalyticsEvent,
        forms.proformaForm,
        getVisibleFieldValues
    ]);
    // Register the validation and serialization functions with the parent Formik form
    (0, $bSJIT.useEffect)(()=>{
        if (registerProformaForm) registerProformaForm(validateProformaForm, serializeProformaForm);
    }, [
        registerProformaForm,
        validateProformaForm,
        serializeProformaForm
    ]);
};
const $1d68a219d7534246$export$342ba682679145b9 = (forms)=>{
    const { setFieldCustomErrors: setFieldCustomErrors } = (0, $5JwFL.usePublicFormRendererActions)();
    const fieldErrors = (0, $9OtAk.useFieldErrors)();
    (0, $bSJIT.useEffect)(()=>{
        if (!fieldErrors) return;
        // Cast TemplateForm to ProformaForm - the uuid field is optional in common-core but required in form-renderer types
        const proformaFieldErrors = (0, $9syXG.convertJiraFieldErrors)(forms.proformaForm, fieldErrors);
        setFieldCustomErrors(proformaFieldErrors);
    }, [
        forms.proformaForm,
        fieldErrors,
        setFieldCustomErrors
    ]);
};
const $1d68a219d7534246$export$4668d6b615699b79 = ()=>{
    const { isFileUploadInProgress: isFileUploadInProgress } = (0, $5JwFL.usePublicFormRendererState)();
    const blockFormSubmission = (0, $9OtAk.useBlockFormSubmission)();
    (0, $bSJIT.useEffect)(()=>{
        blockFormSubmission(isFileUploadInProgress);
    }, [
        blockFormSubmission,
        isFileUploadInProgress
    ]);
};

});
parcelRegister("fuhuQ", function(module, exports) {
$parcel$export(module.exports, "buildFormCreatedAnalyticsAttributes", () => $2f70ed3c7e0bb70d$export$4096a9ea4fa01adb);

var $dS4H4 = parcelRequire("dS4H4");
const $2f70ed3c7e0bb70d$export$4096a9ea4fa01adb = (templateForm)=>({
        templateFormId: templateForm.design.settings.templateId,
        formId: 1,
        hasCascadingFields: Object.values(templateForm.design.questions).some((question)=>question.type === (0, $dS4H4.FormQuestionType).ChoiceCascading)
    });

});


parcelRegister("ly1uh", function(module, exports) {
$parcel$export(module.exports, "KnowledgeBaseSuggestionsContextProvider", () => $cb7ac815874998c2$export$36773fe0f7a08abe);
$parcel$export(module.exports, "useSummaryFieldId", () => $cb7ac815874998c2$export$273528fec63ae8fd);
$parcel$export(module.exports, "useKnowledgeBaseArticles", () => $cb7ac815874998c2$export$d35aa35c9383a75c);

var $bSJIT = parcelRequire("bSJIT");
const $cb7ac815874998c2$var$SummaryFieldIdContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $cb7ac815874998c2$var$KnowledgeBaseArticlesContext = /*#__PURE__*/ (0, $bSJIT.createContext)([]);
const $cb7ac815874998c2$export$36773fe0f7a08abe = ({ summaryFieldId: summaryFieldId, knowledgeBaseArticles: knowledgeBaseArticles, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cb7ac815874998c2$var$SummaryFieldIdContext.Provider, {
        value: summaryFieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cb7ac815874998c2$var$KnowledgeBaseArticlesContext.Provider, {
        value: knowledgeBaseArticles
    }, children));
};
const $cb7ac815874998c2$export$273528fec63ae8fd = ()=>(0, $bSJIT.useContext)($cb7ac815874998c2$var$SummaryFieldIdContext);
const $cb7ac815874998c2$export$d35aa35c9383a75c = ()=>(0, $bSJIT.useContext)($cb7ac815874998c2$var$KnowledgeBaseArticlesContext);

});

parcelRegister("5smeJ", function(module, exports) {
$parcel$export(module.exports, "KnowledgeBaseSuggestionFieldContainer", () => $3088e104f1cfa368$export$eab582729ebef14);

var $bSJIT = parcelRequire("bSJIT");

var $k9e9R = parcelRequire("k9e9R");

var $gUpf2 = parcelRequire("gUpf2");

var $9OtAk = parcelRequire("9OtAk");

var $ly1uh = parcelRequire("ly1uh");
const $3088e104f1cfa368$export$eab582729ebef14 = ({ children: children, fieldId: fieldId })=>{
    const summaryFieldId = (0, $ly1uh.useSummaryFieldId)();
    const knowledgeBaseArticles = (0, $ly1uh.useKnowledgeBaseArticles)();
    const portalId = (0, $9OtAk.usePortalId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        paddingBlockStart: "space.050"
    }, children, String(fieldId) === String(summaryFieldId) && knowledgeBaseArticles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k9e9R.KbSuggestedArticles), {
        articles: knowledgeBaseArticles,
        connectedToForm: true,
        portalId: portalId
    }));
};

});

parcelRegister("fJGzM", function(module, exports) {
$parcel$export(module.exports, "useKnowledgeBaseSuggestions", () => $00fccdf7b8ebd0ef$export$f0a0b3901dccb26);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $6WltM = parcelRequire("6WltM");

var $k2MWg = parcelRequire("k2MWg");

var $h92tT = parcelRequire("h92tT");

var $429NB = parcelRequire("429NB");

var $9OtAk = parcelRequire("9OtAk");

var $6j0Ff = parcelRequire("6j0Ff");
const $00fccdf7b8ebd0ef$export$a1f55f5bc293aaab = (article)=>({
        id: article.articleId,
        name: article.articleTitle,
        articleSnippet: article.articleSnippet,
        pageVersion: article.articleVersion,
        score: article.snippetScore,
        isSmartSnippet: article.isSmartSnippet,
        linkedPortals: article.linkedPortals,
        sourceType: article.articleSource,
        articleUrl: article.articleUrl
    });
const $00fccdf7b8ebd0ef$var$USER_TYPING_DEBOUNCE_TIME = 500;
// These don't have matching entries in the ActionSubject / Action enums in
// @atlassian/proforma-utils/analytics — they're help-center-specific values carried
// over from the legacy use-on-field-change hook. Not worth adding to the platform
// package since these analytics will be replaced with UFO instrumentation.
const $00fccdf7b8ebd0ef$var$KB_SUGGESTION_ACTION_SUBJECT = 'kbSuggestionFieldProforma';
const $00fccdf7b8ebd0ef$var$KB_SUGGESTION_LOADED_ACTION = 'loaded';
const $00fccdf7b8ebd0ef$export$dee88777e0a53d4c = ({ event: event, knowledgeBase: knowledgeBase, knowledgeBaseSearchFetch: knowledgeBaseSearchFetch, searchCounterRef: searchCounterRef, setKnowledgeBaseArticles: setKnowledgeBaseArticles, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldValue = event.fieldValue;
    const hasText = fieldValue && 'text' in fieldValue;
    const trimmedValue = hasText ? fieldValue.text.trim() : '';
    if (!trimmedValue) {
        setKnowledgeBaseArticles([]);
        return;
    }
    searchCounterRef.current += 1;
    const currentSearch = searchCounterRef.current;
    const isStaleSearch = ()=>searchCounterRef.current !== currentSearch;
    knowledgeBaseSearchFetch({
        labels: knowledgeBase ? knowledgeBase.labels : [],
        query: trimmedValue,
        resultLimit: 3
    }).then((response)=>{
        if (isStaleSearch()) return;
        (0, $k2MWg.fireTrackAnalytics)(createAnalyticsEvent({}), `${$00fccdf7b8ebd0ef$var$KB_SUGGESTION_ACTION_SUBJECT} ${$00fccdf7b8ebd0ef$var$KB_SUGGESTION_LOADED_ACTION}`);
        setKnowledgeBaseArticles(response.articles.map($00fccdf7b8ebd0ef$export$a1f55f5bc293aaab));
    }).catch((error)=>{
        const status = error instanceof Error && 'status' in error ? error.status : undefined;
        if (status === undefined || !(0, $h92tT.isNetworkOrClientErrorCode)(status)) (0, $k2MWg.fireTrackAnalytics)(createAnalyticsEvent({}), `${$00fccdf7b8ebd0ef$var$KB_SUGGESTION_ACTION_SUBJECT} ${(0, $429NB.Action).FAILED}`);
    });
};
const $00fccdf7b8ebd0ef$export$f0a0b3901dccb26 = (proformaForm)=>{
    const knowledgeBase = (0, $9OtAk.useKnowledgeBase)();
    const { fetch: knowledgeBaseSearchFetch } = (0, $6j0Ff.useKnowledgeBaseSearchService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [knowledgeBaseArticles, setKnowledgeBaseArticles] = (0, $bSJIT.useState)([]);
    const searchCounterRef = (0, $bSJIT.useRef)(0);
    const summaryFieldId = (0, $bSJIT.useMemo)(()=>{
        for (const [fieldId, question] of Object.entries(proformaForm.design.questions)){
            if (question.jiraField === 'summary') return fieldId;
        }
        return null;
    }, [
        proformaForm
    ]);
    const onFieldChanged = (0, $bSJIT.useMemo)(()=>{
        const debouncedOnSummaryFieldChanged = (0, $4ZMmh.debounce)((event)=>{
            $00fccdf7b8ebd0ef$export$dee88777e0a53d4c({
                event: event,
                knowledgeBase: knowledgeBase,
                knowledgeBaseSearchFetch: knowledgeBaseSearchFetch,
                searchCounterRef: searchCounterRef,
                setKnowledgeBaseArticles: setKnowledgeBaseArticles,
                createAnalyticsEvent: createAnalyticsEvent
            });
        }, $00fccdf7b8ebd0ef$var$USER_TYPING_DEBOUNCE_TIME);
        return (event)=>{
            if (!summaryFieldId || event.fieldId !== summaryFieldId) return;
            debouncedOnSummaryFieldChanged(event);
        };
    }, [
        summaryFieldId,
        knowledgeBase,
        knowledgeBaseSearchFetch,
        createAnalyticsEvent
    ]);
    return {
        summaryFieldId: summaryFieldId,
        knowledgeBaseArticles: knowledgeBaseArticles,
        onFieldChanged: onFieldChanged
    };
};

});
parcelRegister("6j0Ff", function(module, exports) {
$parcel$export(module.exports, "useKnowledgeBaseSearchService", () => $40cf1baa0b770727$export$90d5c1125e3cd8d8);

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $51XYw = parcelRequire("51XYw");

var $bWiRx = parcelRequire("bWiRx");

var $9OtAk = parcelRequire("9OtAk");

var $2MXlX = parcelRequire("2MXlX");
const $40cf1baa0b770727$export$90d5c1125e3cd8d8 = ()=>{
    const projectId = (0, $9OtAk.useProjectId)();
    const requestTypeId = (0, $9OtAk.useRequestTypeId)();
    const request = (0, $bSJIT.useCallback)(({ labels: labels, query: query, resultLimit: resultLimit })=>{
        const activationId = (0, $fuVmc.getMeta)('activation-id');
        const params = new URLSearchParams();
        if (labels) labels.forEach((label)=>params.append('labels', label));
        params.set('searchQuery', query);
        params.set('limit', String(resultLimit));
        const queryString = params.toString();
        let uri;
        if (requestTypeId) uri = `${0, $2MXlX.APOLLO_STARGATE_URL_PREFIX}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
        else uri = `${0, $2MXlX.APOLLO_STARGATE_URL_PREFIX}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
        return (0, $51XYw.fetchJson)(uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }, [
        projectId,
        requestTypeId
    ]);
    return (0, $bWiRx.useService)(request);
};

});


parcelRegister("lJULG", function(module, exports) {
$parcel$export(module.exports, "useProformaFormDirty", () => $0a8d651037198bc7$export$e90246be8cc9d716);

var $bSJIT = parcelRequire("bSJIT");

var $9OtAk = parcelRequire("9OtAk");
const $0a8d651037198bc7$export$e90246be8cc9d716 = ()=>{
    const setProformaFormDirtyAction = (0, $9OtAk.useSetProformaFormDirty)();
    const portalId = (0, $9OtAk.usePortalId)();
    const requestTypeId = (0, $9OtAk.useRequestTypeId)();
    const proformaFormIsDirty = (0, $9OtAk.useProformaFormIsDirty)();
    const proformaFormIsDirtyRef = (0, $bSJIT.useRef)(proformaFormIsDirty);
    (0, $bSJIT.useEffect)(()=>{
        proformaFormIsDirtyRef.current = proformaFormIsDirty;
    }, [
        proformaFormIsDirty
    ]);
    const onProformaFormDirty = (0, $bSJIT.useCallback)(()=>{
        if (!proformaFormIsDirtyRef.current && setProformaFormDirtyAction) setProformaFormDirtyAction({
            portalId: portalId,
            requestTypeId: requestTypeId,
            isDirty: true
        });
    }, [
        portalId,
        requestTypeId,
        setProformaFormDirtyAction
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (setProformaFormDirtyAction) setProformaFormDirtyAction({
                portalId: portalId,
                requestTypeId: requestTypeId,
                isDirty: false
            });
        };
    }, [
        portalId,
        requestTypeId,
        setProformaFormDirtyAction
    ]);
    return onProformaFormDirty;
};

});



parcelRegister("9oPk5", function(module, exports) {
$parcel$export(module.exports, "filter", () => $e3f9bbcd19857ca0$export$3dea766d36a8935f);

var $hMBe3 = parcelRequire("hMBe3");
function $e3f9bbcd19857ca0$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $hMBe3.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});

parcelRegister("Ta6C9", function(module, exports) {
$parcel$export(module.exports, "getDimensionsWithDefault", () => $495ceed8aac696eb$export$36acad525b1fb57b);
const $495ceed8aac696eb$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("cw1fH", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $f6d0df9b2c173384$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $gXAfF = parcelRequire("gXAfF");
const $f6d0df9b2c173384$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: (0, $gXAfF.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("gXAfF", function(module, exports) {
$parcel$export(module.exports, "wrapperStyles", () => $9ee7ec6ea09cf5f4$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $kCE0b = parcelRequire("kCE0b");
const $9ee7ec6ea09cf5f4$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $kCE0b.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $kCE0b.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("kCE0b", function(module, exports) {
$parcel$export(module.exports, "center", () => $e6f3d73a7bae77e8$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $e6f3d73a7bae77e8$export$7a57f79000377ca2);
const $e6f3d73a7bae77e8$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $e6f3d73a7bae77e8$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $e6f3d73a7bae77e8$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $e6f3d73a7bae77e8$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});



parcelRegister("fyJNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $78d3d7a23857cdc1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $gdUUy = parcelRequire("gdUUy");

var $1DGz6 = parcelRequire("1DGz6");

var $b2ees = parcelRequire("b2ees");
const $78d3d7a23857cdc1$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});
const $78d3d7a23857cdc1$var$CardLoadingWithContext = ()=>{
    const props = (0, $bSJIT.useContext)($78d3d7a23857cdc1$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b2ees.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $78d3d7a23857cdc1$var$loadCardWithMediaClient() {
    return (parcelRequire("iGQv0"));
}
const $78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>$78d3d7a23857cdc1$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$CardLoadingWithContext, null)
});
const $78d3d7a23857cdc1$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>$78d3d7a23857cdc1$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $78d3d7a23857cdc1$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1DGz6.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardContext.Provider, {
        value: props
    }, (0, $gdUUy.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable, props)));
};
$78d3d7a23857cdc1$var$CardLoader.preload = ()=>{
    if ((0, $gdUUy.fg)('platform_media_react19_support')) $78d3d7a23857cdc1$var$loadCardWithMediaClient().then(()=>{});
    else {
        var _MediaCardWithMediaCl;
        (_MediaCardWithMediaCl = $78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable.preload) === null || _MediaCardWithMediaCl === void 0 || _MediaCardWithMediaCl.call($78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable);
    }
};
var $78d3d7a23857cdc1$export$2e2bcd8739ae039 = $78d3d7a23857cdc1$var$CardLoader;

});
parcelRegister("b2ees", function(module, exports) {
$parcel$export(module.exports, "CardLoading", () => $5cb084c50dfe3d13$export$5d25853fd6bdf402);

var $bSJIT = parcelRequire("bSJIT");

var $ljFME = parcelRequire("ljFME");

var $Ta6C9 = parcelRequire("Ta6C9");

var $cw1fH = parcelRequire("cw1fH");
const $5cb084c50dfe3d13$export$5d25853fd6bdf402 = ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $Ta6C9.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cw1fH.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljFME.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }));
};

});
parcelRegister("ljFME", function(module, exports) {
$parcel$export(module.exports, "LoadingBar", () => $d7e29441a6d1fe20$export$6665614bc5d690f6);
/* loadingBar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $cyIUy = parcelRequire("cyIUy");
const $d7e29441a6d1fe20$var$TICK_INTERVAL_MS = 1000;
const $d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE = 0.9;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $d7e29441a6d1fe20$var$useLayoutEffect = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
const $d7e29441a6d1fe20$var$messages = (0, $f0Pt4.defineMessages)({
    loadingBarLabel: {
        id: 'fabric.media.loading_bar_label',
        defaultMessage: 'Loading',
        description: 'Aria label for the loading bar shown while a media card is loading'
    }
});
const $d7e29441a6d1fe20$var$trackStyles = null;
const $d7e29441a6d1fe20$var$fillStyles = null;
const $d7e29441a6d1fe20$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $d7e29441a6d1fe20$export$6665614bc5d690f6 = ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $4vLTk.default)();
    const [progress, setProgress] = (0, $bSJIT.useState)(animationDisabled ? $d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $bSJIT.useRef)();
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    $d7e29441a6d1fe20$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $d7e29441a6d1fe20$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($d7e29441a6d1fe20$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: {
            width: `${$d7e29441a6d1fe20$var$clampToPercent(progress)}%`
        },
        className: (0, $9fU1q.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ])
    }));
};

});


parcelRegister("iGQv0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cqzIS"),
    $kOunM("hyEGg"),
    $kOunM("eyRof")
]).then(()=>parcelRequire('3NCBI'));

});


parcelRegister("iHNht", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b8aeb40a0dd9aac20350a989eb3c9ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9e2784b28f796c2$var$_react = $d9e2784b28f796c2$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $d9e2784b28f796c2$var$_iconNew = $d9e2784b28f796c2$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $d9e2784b28f796c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cloud-arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9e2784b28f796c2$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $d9e2784b28f796c2$var$_react.default.createElement($d9e2784b28f796c2$var$_iconNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$d9e2784b28f796c2$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $d9e2784b28f796c2$var$_default = module.exports.default = $d9e2784b28f796c2$var$CloudArrowUpIcon;

});

parcelRegister("8AI2A", function(module, exports) {
$parcel$export(module.exports, "BrowserLoader", () => $0b4bb44b5957561c$export$3ce634ac4a869e2c);

var $bSJIT = parcelRequire("bSJIT");


class $0b4bb44b5957561c$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncBrowser';
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("hTzgT"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("hTzgT", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("eqf5q")
]).then(()=>parcelRequire('iB3wS'));

});


parcelRegister("7tc9a", function(module, exports) {
$parcel$export(module.exports, "DropzoneLoader", () => $a3a0cb02c40d3d21$export$66201d263cd6342);

var $bSJIT = parcelRequire("bSJIT");



class $a3a0cb02c40d3d21$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncDropzone';
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("V4wSv")),
            (parcelRequire("agaIQ"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("V4wSv", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("dwvI2")
]).then(()=>parcelRequire('esQLv'));

});

parcelRegister("agaIQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gCHew").then(()=>parcelRequire('8gt2G'));

});



//# sourceMappingURL=proforma-request-create.3531abaa.js.map
